import AppConstants from '../../config/app.constants';

class ATMCountController {

    /*@ngInject*/
    constructor($state, $q, $window, $scope, $http, Modal, LocationService, User, SetupService, DateUtil, ShipmentService, BranchFundingSourceService, HoldService,
                AtmResidualService, BulkCashService, Sound, $translate, $rootScope, DataCounter, $location, UserBranchFundingSourceService, UsersService, DenominationService, AtmResidualDepositService, ShiptypeService, Navigation, UserService, CurrencyService, FetchReactData) {
        this.$q = $q;
        this.$state = $state;
        this.$window = $window;
        this.$http = $http;
        this.FetchReactData = FetchReactData;
        this.LocationService = LocationService;
        this.User = User;
        this.SetupService = SetupService;
        this.DateUtil = DateUtil;
        this.ShipmentService = ShipmentService;
        this.BranchFundingSourceService = BranchFundingSourceService;
        this.AtmResidualService = AtmResidualService;
        this.BulkCashService = BulkCashService;
        this.UsersService = UsersService;
        this.HoldService = HoldService;
        this.Modal = Modal;
        this.$scope = $scope;
        this.Sound = Sound;
        this.$rootScope = $rootScope;
        this.DataCounter = DataCounter;
        this.$location = $location;
        this.DenominationService = DenominationService;
        this.AtmResidualDepositService = AtmResidualDepositService;
        this.ShiptypeService = ShiptypeService,
        this.$translate = $translate;
        this.Navigation = Navigation;
        this.UserBranchFundingSourceService = UserBranchFundingSourceService;
        this.UserService = UserService;
        this.CurrencyService = CurrencyService;
        this.currencySymbol = '$';
        this.currencyPattern = /^(\$|€|CA\$|C\$|J\$)?([0-9 _ ,]*(\.\d*)?)$/;
        this.currencyPatternStrict = /^(\$|€|CA\$|C\$|J\$)?((\d{1,3}(,\d{3})*)|\d*)(\.\d+)?$/;
        this.residualCashAmountPattern = /^$|^(\$|€|CA\$|C\$|J\$)?\d+(?:\.00)?$/;
        this.residualCoinAmountPattern = /^$|^(\$|€|CA\$|C\$|J\$)?(?:(?:\d+(?:\.\d{0,2})?)|(?:\.\d{1,2}))$/;
        this.currencyData = [];
        this.model = {
            branch: User.getUser().branchId,
            vaultDate: '',
            beginTime: '',
            atmResidual: [],
            loggedInUserId: User.getUser().id,
            branchCounters: [],
            selectedBranchCounter: null,
            hasCounters: false,
            unfitTotalCashCounted: 0,
            depositRecord: {
                declaredTotalAmount: 0,
                countedVariance: 0,
                totalAmount: 0,
                statedTotalAmount: 0,
                depositShipment: null,
                depositRecord: null,
                denominations: [],
                receiptAmount: 0,
                childTotalDeposit: 0,
                coinTotalDeposit: 0,
                unfitTotalDeposit: 0,
                notes: '',
                previousNotes: '',
            }
            // ledgerTransaction: []
        }
        this.lastScanned = "";
        this.isError = true;
        this.successCount = 0;
        this.orderType = "";
        this.atmResidualRecord = { notes: '' };
        this.shipmentData = [];
        this.enterSuffix = AppConstants.scan_enter_suffix;
        this.pickupDate = "";
        this.remainingResiduals = [];
        this.allDenominations = [];
        this.isEdit = false;
        this.$rootScope.$broadcast('routeChange', '/app/atm-count');
        this.locationData = '';
        this.isEmergencyType = '';
        this.branchTimeZone = '';
        this.showCoins = false;
        this.showUnfit = false;
        this.showCash = true;
        this.shiptype = 'deposit';
        this.MAXLIMIT = 1000;
        this.isBulkCash = false;
        this.autoCounting = false;
        
        this.isBulkDeposit = false;
        this.isBulkDepositCommit = false;
        this.browserTimezone = moment.tz.guess();
        this.countRestriction = { enabled: false, shiptypeId: null };
        this._initBulkDepositDataStructures();
    }


    roundTo2DecimalsForDisplay(value) {
        if (value == null || value === '') return '0';
        const str = String(value).replace(/,/g, '').replace(/\s/g, '');
        const num = Number(str);
        if (!Number.isFinite(num)) return value != null && value !== '' ? String(value) : '0';
        const rounded = Math.round(num * 100) / 100;
        return rounded.toLocaleString(undefined, { maximumFractionDigits: 2 });
    }

    _getDefaultBulkDepositData() {
        return {
            shipment: null,
            statedTotal: 0,
            declaredTotal: 0,
            countedTotal: 0,
            countedVariance: 0,
            bags: {},
            metadata: {
                hasActiveBulkDeposit: false,
                isClosingBulkDeposit: false,
                nextBagIndex: 0,
                shiptype: {
                    countable: false,
                    daysToCount: 0
                },
                branchCurrentVaultDate: null,
                shipmentVaultDate: null
            }
        };
    }
    
    _getDefaultActiveBagData() {
        return {
            bagIndex: null,
            isEditMode: false,
            isCounting: false,
            originalBagValues: null,
            originalDepositData: null,
            bag: null,
            depositData: this._getDefaultDepositData()
        };
    }
    
    _getDefaultDepositData() {
        return {
            depositShipment: null,
            depositRecord: null,
            declaredTotalAmount: 0,
            countedVariance: 0,
            totalAmount: 0,
            statedTotalAmount: 0,
            denominations: [],
            previousDenominations: [],
            childTotalDeposit: 0,
            coinTotalDeposit: 0,
            unfitTotalDeposit: 0,
            codFlags: null
        };
    }

    _getDefaultBagData() {
        return {
            trackingId: '',
            declaredAmount: null,
            countedAmount: 0,
            countedVariance: 0,
            status: 'pending',
            shipmentId: null,
            depositRecordId: null,
            countCompletedAt: null,
            depositRecord: null,
            cashDenomTotals: 0,
            coinDenomTotals: 0,
            unfitDenomTotals: 0
        };
    }

    _initBulkDepositDataStructures() {
        this.bulkDepositData = this._getDefaultBulkDepositData();
        this.activeBagData = this._getDefaultActiveBagData();
    }

    $onInit() {
        this.$q.all([
            (this.model.branch = this.User.getUser().branchId),
            this.SetupService.get(this.model.branch),
            this.DenominationService.all({}, null, this.MAXLIMIT),
            this.UserService.getBranchCounters(this.model.branch),
            this.UsersService.get(this.model.loggedInUserId)
        ])
            .then((data) => {
                this.getAllLocation('', 0);
                this.model.vaultDate = this.DateUtil.convertToDate(data[1].currentVaultDate);
                this.branchTimeZone = data[1].timezone;
                this.minVaultDate = {
                    maxDate: this.model.vaultDate
                }
                this.model.depositRecord.denominations = angular.copy(this.denominationsDataMap(data[2].results));
                this.allDenominations = this.model.depositRecord.denominations;

                const countersRes = data[3] || {};
                const userDetail = data[4] || {};
                this.model.branchCounters = (countersRes.branchCounters || []).map((c) => ({
                    id: c.id,
                    name: c.name,
                    sn: c.serialNumber
                }));
                this.model.hasCounters = this.model.branchCounters.length > 0;

                const isWebUser = !userDetail.customerUser && !!userDetail.email; 
                 if(!this.model.hasCounters){
                    this.disableCounterSelection = true;
                    this.model.selectedBranchCounter = null;
                 } else if(userDetail.supervisor){
                    this.disableCounterSelection = false;
                 } else if (isWebUser) {
                    const found = userDetail.branchCounterId ? this.model.branchCounters.find(bc => bc.id === userDetail.branchCounterId): null;
                    if (found) {
                        this.model.selectedBranchCounter = found;
                        this.disableCounterSelection = true;
                    } else {
                        this.model.selectedBranchCounter = null;
                        this.disableCounterSelection = true;
                        this.Modal.errorModal('error.web_user_counter_required');
                    }
                } else {
                    this.disableCounterSelection = false;
                }
            })
            .then(() => {
                this.loadPermission();
                this.loadCurrencyData();
            })
            .catch((err) => {
                console.log(err);
            })
    }

    loadCurrencyData() {
        if (this.currencyData.length > 0) {
            return this.$q.resolve(this.currencyData);
        }

        return this.SetupService.get(this.model.branch)
            .then((setup) => {
                const currencyIds = Array.isArray(setup.availableCurrencyIds) && setup.availableCurrencyIds.length > 0 
                    ? setup.availableCurrencyIds 
                    : [setup.currencyId];

                const currencySearchObj = {
                    queryJSON: {
                        rules: currencyIds.map(id => ({
                            field: "id",
                            condition: "=",
                            data: id
                        })),
                        operator: "OR"
                    }
                };

                return this.CurrencyService.all(currencySearchObj, 0, 100);
            })
            .then((data) => {
                this.currencyData = data.results || [];
                return this.currencyData;
            })
            .catch((err) => {
                console.log('Error loading currency data:', err);
                this.currencyData = [];
                return [];
            });
    }

    setCurrencySymbol() {
        if (!this.model.locationId || !this.model.locationId.currencyId) {
            this.currencySymbol = '$';
            return;
        }

        const currencyId = this.model.locationId.currencyId;
        
        if (Array.isArray(this.currencyData) && this.currencyData.length > 0) {
            const currency = this.currencyData.find(c => c.id === currencyId);
            this.currencySymbol = (currency && currency.symbol) ? currency.symbol : '$';
        } else {
            this.loadCurrencyData().then(() => {
                const currency = this.currencyData.find(c => c.id === currencyId);
                this.currencySymbol = (currency && currency.symbol) ? currency.symbol : '$';
            });
        }
    }

    canUseCounter() {
        if (!this.model.hasCounters) return true;
        return !!(this.model.selectedBranchCounter && this.model.selectedBranchCounter.id);
    }

    onCounterSelected() {
        this.resetData();
        this.model.locationId = null;
    }

    canShowAutoCountButton() {
        return this.model.hasCounters
            && !!(this.model.selectedBranchCounter && this.model.selectedBranchCounter.id)
            && this.shiptype === 'residual'
            && (this.model.atmResidual || []).length > 0
            && this.isEdit;
    }

    autoCountFromCounter() {
        if (!this.canShowAutoCountButton() || this.autoCounting) return;
        this.autoCounting = true;
        const branchId = this.model.branch;
        const vaultDate = moment(this.model.vaultDate).format('YYYY-MM-DD');
        const sn = this.model.selectedBranchCounter.sn;
        this.$http.get(`${AppConstants.api}/cashcounts/latest`, { params: { branchId, vaultDate, sn } })
            .then((res) => {
                if (!res || !res.data || !res.data.data) return;
                const counts = res.data.data.counts || {};
                if (!counts || Object.keys(counts).length === 0) return;
                (this.model.atmResidual || []).forEach((row, idx) => {
                    const key = row.denominationId; // e.g., 'USD20'
                    const billCount = Number(counts[key]);
                    if (Number.isFinite(billCount) && billCount > 0) {
                        const face = Number(row.faceValue) || 0;
                        row.countedResidual = billCount * face;
                        row.denomCountedResidual = billCount.toLocaleString();
                        this.calculateAmount(idx);
                    }
                });
                this.totalAmount();
            })
            .catch((err) => {console.error(err)})
            .finally(() => { this.autoCounting = false; });
    }

    loadPermission() {
        this.acl = {};
        this.hasACL = {};

        ['atm_count'].forEach((permissionKey) => {
            this.acl[permissionKey] = this.User.getACL(permissionKey);

            this.hasACL[permissionKey] = {};

            this.acl[permissionKey].forEach((permission) => {
                this.hasACL[permissionKey][permission] = true;
            });
        });
    }

    focusElementById(id) {
        setTimeout(() => {
            document.getElementById(id).focus()
        }, 300);
    }

    // Get current time
    getTime(time) {
        if (!time) {
            return time;
        }

        time = time.split(':');

        let d = new Date();

        d.setHours(+time[0]);
        d.setMinutes(time[1]);
        d.setSeconds(0);
        d.setMilliseconds(0);

        return d;
    }

    // Get fundingSource
    locationSearchObj = (searchKey) => {
        searchKey = searchKey || '';
        const searchObj = {
            queryJSON: {
                rules: [
                    {
                        field: 'branchId',
                        condition: '=',
                        data: this.model.branch
                    },
                    {
                        group: {
                            rules: [{
                                field: 'locationId',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            },
                            {
                                field: 'sourceName',
                                condition: 'like',
                                data: '%' + searchKey + '%'
                            }
                            ],
                            operator: 'OR'
                        }
                    }
                ],
                operator: 'AND'
            }
        };
        return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    getAllLocation(searchKey, offset) {
        this.UserBranchFundingSourceService.getBranchFundingSource(this.model.loggedInUserId, this.model.branch)
            .then((data) => {
                if (offset === 0) {
                    this.totalRecords = data.total;
                    this.locationLists = this.mappingLocationData(data.results);
                }
                else {
                    const locations = this.mappingLocationData(data.results);
                    this.locationLists = this.locationLists.concat(locations);
                }
                return data.results
            })
            .then((fundingSourceData) => {
                this.loadAtmCount(fundingSourceData)
            })
    }

    mappingLocationData(locations) {
        return locations.map((location) => {
            return {
                Key: location.id + " | " + location.locationId + " | " + location.sourceName,
                Value: location.locationId,
                Id: location.id,
                EditCountAnytime: location.editCountAnytime,
                varianceCheckEnabled: location.varianceCheckEnabled || false,
                varianceThreshold: location.varianceThreshold,
                currencyId: location.currencyId
            }
        });
    }

    depositCommitDisabled() {
        let patterns = /^[0-9]\d*(\,\d+)?$/
        let invalidValues = false;
        this.model.depositRecord.denominations.forEach((denom) => {
            if (!patterns.test(denom.totalCounted)) {
                invalidValues = true;
            }
        })
        let totalBills = Number(this.model.depositRecord.childTotalDeposit) + Number(this.model.depositRecord.coinTotalDeposit) + Number(this.model.depositRecord.unfitTotalDeposit);
        return (this.model.depositRecord.totalAmount !== totalBills) || !this.model.bagId || !this.model.beginTime || !this.pickupDate || totalBills < 0 || invalidValues;
    }

    denominationsDataMap(list) {
		return list.map((item) => {
			return {
				id: item.id,
				label: item.id + ' | ' + item.name,
				faceValue: item.faceValue,
                totalCounted: item.totalCounted || 0,
                coinFlag: item.coinFlag || false,
                totalValue: item.totalCounted * item.faceValue,
                currencyId: item.currencyId,
                shiptypeId: item.shiptypeId,
                unfit: item.unfit || false,
                symbol: item.currency && item.currency.symbol ? item.currency.symbol : null
			}
		})
	}

    toggleTab(tabType) {
        switch(tabType) {
            case 'cash':
                this.showCash = !this.showCash;
                break;
            case 'coin':                
                this.showCoins = !this.showCoins;
                break;
            case 'unfit':
                this.showUnfit = !this.showUnfit;
                break;
            default:
                this.showCash = true;
                this.showCoins = false;
                this.showUnfit = false;
        }
        
        if(!this.showUnfit && !this.showCoins && !this.showCash){
            this.showCash = true;
            this.showCoins = false;
            this.showUnfit = false;
        }
	}

    depositDenomChange(denomId) {
        let index = this.model.depositRecord.denominations.findIndex((item) => item.id === denomId);
        let countedTotal = Number(this.model.depositRecord.denominations[index].totalCounted * this.model.depositRecord.denominations[index].faceValue) || 0;
        this.model.depositRecord.denominations[index].totalValue = countedTotal;
        this.depositCountTotal();
    }

    depositCountTotal() {
        this.model.depositRecord.childTotalDeposit = this.model.depositRecord.denominations.filter(denom => !denom.coinFlag && !denom.unfit).reduce((sum, denom) => {
            return sum + (Number(denom.totalCounted * denom.faceValue) || 0);
        }, 0);
        this.model.depositRecord.coinTotalDeposit = this.model.depositRecord.denominations.filter(denom => denom.coinFlag && !denom.unfit).reduce((sum, denom) => {
            return sum + (Number(denom.totalCounted * denom.faceValue) || 0);
        }, 0);

       const unfitDenomsViewBased = this.getViewUnfitDenominations();
        this.model.depositRecord.unfitTotalDeposit = unfitDenomsViewBased.reduce((sum, denom) => {
            if (this.shiptype === 'deposit') {
                return sum + (Number(denom.totalValue) || 0);
            } else {
                return sum + (Number(denom.totalCashCounted) || 0);
            }
        }, 0);
        this.model.depositRecord.totalAmount = Number(this.model.depositRecord.childTotalDeposit) + Number(this.model.depositRecord.coinTotalDeposit) + Number(this.model.depositRecord.unfitTotalDeposit);
        this.model.depositRecord.countedVariance = Number(this.model.depositRecord.totalAmount) - Number(this.model.depositRecord.declaredTotalAmount);
    }
    hasUnfitDenoms(){
        return this.getViewUnfitDenominations().length > 0;
    }

    getFilteredUnfitDenominations() {
        if (!this.model.depositRecord.denominations || !this.childShipmentData || !Array.isArray(this.childShipmentData)) {
            return [];
        }
        
        const unfitDenoms = this.model.depositRecord.denominations.filter(denom => denom.unfit);
                return unfitDenoms.filter(unfitDenom => {
            return this.childShipmentData.some(shipment => 
                shipment.faceValue === unfitDenom.faceValue && 
                shipment.shiptypeId === unfitDenom.shiptypeId
            );
        });
    }

    getViewUnfitDenominations() {
        if (this.shiptype === 'residual') {
            return this.getFilteredUnfitDenominations();
        }
        const denoms = this.model.depositRecord && this.model.depositRecord.denominations ? this.model.depositRecord.denominations : [];
        return denoms.filter(d => d.unfit);
    }

    calculateUnfitAmount(index) {
        const unfitDenoms = this.getFilteredUnfitDenominations();
        if (unfitDenoms[index]) {
            const denom = unfitDenoms[index];
            const countedAmount = Number(denom.totalCashCounted) || 0;
            const faceValue = Number(denom.faceValue) || 0;
            
            if (faceValue > 0) {
                const billCount = countedAmount / faceValue;
                denom.denomTotalCashCounted = billCount.toLocaleString();
                denom.isInvalidAmount = billCount !== Math.floor(billCount);
            } else {
                denom.denomTotalCashCounted = '0';
                denom.isInvalidAmount = false;
            }
            
            this.updateUnfitTotal();
        }
    }

    updateUnfitTotal() {
        const unfitDenoms = this.getFilteredUnfitDenominations();
        this.model.unfitTotalCashCounted = unfitDenoms.reduce((sum, denom) => {
            return sum + (Number(denom.totalCashCounted) || 0);
        }, 0);

        this.depositCountTotal();
        this.model.countedResidualTotalDisplay = (Number(this.model.countedResidualTotal) || 0) + (Number(this.model.unfitTotalCashCounted) || 0);
    }

    initializeUnfitDenominations() {
        if (!this.model.depositRecord.denominations || !this.childShipmentData || !Array.isArray(this.childShipmentData)) {
            return;
        }

        try {
            const matchingUnfitDenoms = this.getFilteredUnfitDenominations();

            matchingUnfitDenoms.forEach(unfitDenom => {
                const matchingShipment = this.childShipmentData.find(shipment => 
                    shipment.faceValue === unfitDenom.faceValue && 
                    shipment.shiptypeId === unfitDenom.shiptypeId
                );
                
                if (matchingShipment) {
                    unfitDenom.totalCashCounted = 0;
                    unfitDenom.denomTotalCashCounted = 0;
                    unfitDenom.shiptypeId = matchingShipment.shiptypeId;
                    unfitDenom.faceValue = matchingShipment.faceValue;
                    unfitDenom.denominationSymbol = matchingShipment.denominationSymbol;
                }
            });

            this.updateUnfitTotal();
        } catch (error) {
            console.log('Error initializing unfit denominations:', error);
        }
    }

    prepareUnfitDenominationsData() {
        const unfitDenoms = this.getFilteredUnfitDenominations();

        if (!unfitDenoms || unfitDenoms.length === 0) {
            return null;
        }

        return unfitDenoms.map(unfitDenom => {
            const matchingShipment = this.childShipmentData.find(shipment => 
                shipment.faceValue === unfitDenom.faceValue && 
                shipment.shiptypeId === unfitDenom.shiptypeId
            );

            if (!matchingShipment) {
                console.warn('No matching shipment found for unfit denomination:', unfitDenom);
                return null;
            }

            return {
                denominationId: unfitDenom.id,
                faceValue: Number(unfitDenom.faceValue),
                amount: Number(unfitDenom.totalCashCounted) || 0,
                quantity: Number(unfitDenom.totalCashCounted) / Number(unfitDenom.faceValue) || 0,
                
                // Shipment details for DEPOSITRECORD
                shipmentId: matchingShipment.residualShipmentId,
                orderNo: matchingShipment.orderNo,
                trackingId: matchingShipment.trackingId,
                fromLocationId: matchingShipment.fromLocationId,
                toLocationId: matchingShipment.toLocationId,
                routeId: matchingShipment.routeId,
                shiptypeId: matchingShipment.shiptypeId,
                currencyId: matchingShipment.currencyId,
                branchId: matchingShipment.branchId || this.model.branch,
                
                isEC: matchingShipment.isEC,
                orderType: matchingShipment.orderType,
                amountLoadRequested: matchingShipment.amountLoadRequested,
                
                fromLocationName: matchingShipment.fromLocationName,
                toLocationName: matchingShipment.toLocationName
            };
        }).filter(item => item !== null);
    }

    restorePreviousUnfitDenominations() {
        if (!this.model.parentAtmResidual || !this.model.parentAtmResidual.orderNo) {
            return;
        }

        if (!this.childShipmentData || !Array.isArray(this.childShipmentData)) {
            return;
        }

        const orderNo = this.model.parentAtmResidual.orderNo;
        const account = this.model.parentAtmResidual.account;

        const shipmentIds = this.childShipmentData.map(shipment => shipment.residualShipmentId).filter(Boolean);
        
        if (shipmentIds.length === 0) {
            return;
        }

        this.AtmResidualService.getExistingUnfitDenominations(orderNo, shipmentIds, account)
            .then((allExistingUnfitData) => {
                if (allExistingUnfitData && allExistingUnfitData.length > 0) {
                    // Restore the unfit denomination values using business logic matching
                    this.restoreUnfitValues(allExistingUnfitData);
                }
            })
            .catch((err) => {
                console.log('Error fetching existing unfit denominations:', err);
            });
    }

    restoreUnfitValues(existingUnfitData) {
        this.model.unfitTotalCashCounted = 0;

        if (this.model.depositRecord && this.model.depositRecord.denominations) {
            this.model.depositRecord.denominations.forEach(denom => {
                
                const existingData = existingUnfitData.find(existing => existing.denominationId === denom.id);
                if (existingData) {
                    denom.totalCashCounted = existingData.amount;
                    const billCount = existingData.amount / existingData.faceValue;
                    denom.denomTotalCashCounted = billCount.toLocaleString();
                    
                    denom.isInvalidAmount = billCount !== Math.floor(billCount);
                    
                    this.model.unfitTotalCashCounted += existingData.amount;
                } else {
                    denom.totalCashCounted = 0;
                    denom.denomTotalCashCounted = 0;
                    denom.isInvalidAmount = false;
                }
            });
        }
        this.model.countedResidualTotalDisplay = (Number(this.model.countedResidualTotal) || 0) + (Number(this.model.unfitTotalCashCounted) || 0);
    }

    isCODShipment() {
        return this.codFlags && 
               this.codFlags.isPackable && 
               this.codFlags.isCRVed;
    }

    setCountRestrictionFromShipment(shipmentRecord) {
        const enabled = !!(shipmentRecord && shipmentRecord.restrictCoinCountByShiptype && shipmentRecord.restrictCoinShiptypeId);
        this.countRestriction = {
            enabled,
            shiptypeId: enabled ? shipmentRecord.restrictCoinShiptypeId : null
        };
    }

    isShiptypeCoinRestrictionEnabled() {
        return !!(this.countRestriction && this.countRestriction.enabled && this.countRestriction.shiptypeId);
    }

    codUnfitFilter = (denom) => {
        if (!denom || !denom.unfit) return false;
        if (this.isShiptypeCoinRestrictionEnabled()) {
            return denom.shiptypeId === this.countRestriction.shiptypeId;
        }
        if (!this.isCODShipment()) return true;

        const includedIds = (this.codFlags && Array.isArray(this.codFlags.includedDenominationIds)) ? this.codFlags.includedDenominationIds : [];
        if (includedIds.length === 0) return false;

        const includedSet = new Set(includedIds);
        const all = (this.model.depositRecord && this.model.depositRecord.denominations) ? this.model.depositRecord.denominations : [];
        const allowed = new Set();
        all.forEach(d => {
            if (!d.unfit && includedSet.has(d.id)) {
                allowed.add(`${d.shiptypeId}|${d.faceValue}`);
            }
        });
        return allowed.has(`${denom.shiptypeId}|${denom.faceValue}`);
    }

    codCashFilter = (denom) => {
        if (!denom || denom.unfit || denom.coinFlag) return false;
        if (this.isShiptypeCoinRestrictionEnabled()) return false;
        if (!this.isCODShipment()) return true;
        const includedIds = (this.codFlags && Array.isArray(this.codFlags.includedDenominationIds)) ? this.codFlags.includedDenominationIds : [];
        if (includedIds.length === 0) return false;
        const includedSet = new Set(includedIds);
        return includedSet.has(denom.id);
    }

    codCoinFilter = (denom) => {
        if (!denom || denom.unfit || !denom.coinFlag) return false;
        if (this.isShiptypeCoinRestrictionEnabled()) {
            return denom.shiptypeId === this.countRestriction.shiptypeId;
        }
        if (!this.isCODShipment()) return true;
        const includedIds = (this.codFlags && Array.isArray(this.codFlags.includedDenominationIds)) ? this.codFlags.includedDenominationIds : [];
        if (includedIds.length === 0) return false;
        const includedSet = new Set(includedIds);
        return includedSet.has(denom.id);
    }

    // update total counted by the total from deposit record
    denomsDataUpdate(denomsData) {
        return this.model.depositRecord.denominations.map((item) => {
            let denomRecord = denomsData.find((denom) => denom.denominationId === item.id);
            let totalCounted = 0;
            let totalValue = 0;
            if (denomRecord) {
                totalCounted = Number((denomRecord.amount / item.faceValue).toFixed(6));
                totalValue = denomRecord.amount; 
            }
			return {
				...item,
                totalCounted,
                totalValue
			}
		})
	}

    // Commit residual shipment and Add entry to ledgerTransaction
    commitResidualShipment(index = 0, addDeposit = false) {
        let shipments = this.parentShipment;
        if (this.isCommit) return;
        if (!this.model.parentAtmResidual) return;
        this.isCommit = true;
        this.monthlySupId = null; 


        let unfitTotal = (this.model.unfitTotalCashCounted) ? this.model.unfitTotalCashCounted : 0;
        let newAmount = (this.model.countedResidualTotal || 0) + unfitTotal;

        return this.getExpectedResidual().then(() => {
        this.checkMonthlyCountLimit(newAmount).then(() => {
            let data = this.model.parentAtmResidual,
                cashReturnedVault =this.model.expectedResidualToSend,
                variance = this.model.varianceToSend,
                orderType = data.orderType,
                expectedResidual = this.model.expectedResidualToSend;
                
            if (orderType == 'A' && ((expectedResidual > 0 && this.model.expectedResidualTotal !== this.model.crvTotal) || this.model.countedResidualTotalDisplay > 0)) {
                this.confirmUpdateShipment() // user confirmation before update `shipment.orderType` (calling before residualCountCommit) 
                    .then((res) => {
                        this.orderType = 'S';
                        return this.commit(index, data, cashReturnedVault, variance, shipments, addDeposit)
                    }).catch(() => {
                        this.isCommit = false;
                    });
            }
            else {
                return this.commit(index, data, cashReturnedVault, variance, shipments, addDeposit)
            }
        }).catch(() => {
            this.isCommit = false;
        });
        });
    }

    commit(index, data, cashReturnedVault, variance, shipments, addDeposit = false) {
        if (variance != 0) { 
            this.Modal.residualComments(shipments, ({ modal, comments }) => {
                this.residualCountCommit(comments, addDeposit)
            }, ({ modal }) => {
                this.focusElementById('residual-commit');
                if (modal) modal.close();
                this.isCommit = false;
            })
        }
        else { // call if variance zero
            return this.residualCountCommit(null, addDeposit)
        }
    }

    residualCountCommit(comments, addDeposit = false) {
        // return this.getExpectedResidual().then(() => {
            const defer = this.$q.defer();
            const pickupDate = moment(this.pickupDate).format('YYYY-MM-DD');
            const pickupTime = moment(this.model.beginTime).format('HH:mm:ss');

            const unfitDenomsData = this.prepareUnfitDenominationsData();
            const unfitTotal = (unfitDenomsData && this.model.unfitTotalCashCounted) ? this.model.unfitTotalCashCounted : 0;
            const totalCountedResidual = this.model.countedResidualTotal + unfitTotal;

            const parentResidual = {
                trackingId: this.model.parentAtmResidual.trackingId,
                actualLoad: this.model.parentAtmResidual.denomActualLoad.split(",").join(''),
                cashReturnedVault: this.model.crvTotal,
                expectedResidual: this.model.parentAtmResidual.expectedResidual,
                countedResidual: totalCountedResidual,
                variance: this.model.varianceToSend,
                denominationId: this.model.parentAtmResidual.denominationId,
                faceValue: this.model.parentAtmResidual.faceValue,
                loadedAmount: this.model.parentAtmResidual.loadedAmount,
                atmResidualId: this.model.parentAtmResidual.atmResidualId,
                residualAmount: this.model.parentAtmResidual.residualAmount,
                comments: comments || this.atmResidualRecord.comment || '',
                notes: this.atmResidualRecord.notes || '',
                transferredAmount: 0,
                dispensedAmount: 0,
                account: this.model.parentAtmResidual.account,
                orderNo: this.model.parentAtmResidual.orderNo,
                manualPriorLoadAmount: this.model.parentAtmResidual.manualPriorLoadAmount,
                divertedAmount: (this.model.parentAtmResidual && this.model.parentAtmResidual.divertedAmount != null) ? this.model.parentAtmResidual.divertedAmount : null
            };

            this.checkSupervisorApproval(this.model.varianceTotal).then((supId) => {
                // Array of children with necessary data
                const children = this.model.atmResidual.map((data, index) => {

                    let divisor = (data.coinPackaging === 'ROLLED' || data.coinPackaging === 'INDIVIDUAL') && data.unitValue != null
                        ? data.unitValue
                        : data.faceValue;

                    // prevent division by zero
                    divisor = divisor || 1;

                    return {
                        trackingId: data.trackingId,
                        actualLoad: data.denomActualLoad.split(",").join(''),
                        cashReturnedVault: Number((data.crv / divisor).toFixed(4)),
                        expectedResidual: data.denomExpectedResidual.split(",").join(''),
                        countedResidual: data.denomCountedResidual.split(",").join(''),
                        variance: Number((data.variance / divisor).toFixed(4)),
                        denominationId: data.denominationId,
                        faceValue: data.faceValue,
                        loadedAmount: data.loadedAmount,
                        atmResidualId: data.atmResidualId,
                        residualAmount: data.residualAmount,
                        comments: comments || this.atmResidualRecord.comment || '',
                        notes: this.atmResidualRecord.notes || '',
                        transferredAmount: Number(((data.transferredAmount || 0) / divisor).toFixed(4)),
                        dispensedAmount: Number(((data.dispensedAmount || 0) / divisor).toFixed(4)),
                        supervisorId: supId,
                        manualPriorLoadAmount: data.manualPriorLoadAmount
                    };
                });

                if (!this.model.parentAtmResidual.finishedAt) {
                    let data = this.model.parentAtmResidual;
                    if (data.actualLoad === 0 && data.crv === data.requestLoad && data.countedResidual === data.requestLoad && 
                       !data.isDeliveryShipmentDeleted && !['T', 'P'].includes(data.orderType)) {
                        this.Modal.confirm({
                            header: this.$translate.instant('itemHolds.converttocrv'),
                            message: this.$translate.instant('atm_residual.convert_to_crv_msg'),
                            callback: (({
                                modal
                            }) => {
                                this.convertToCrv(data, modal);
                                this.isCommit = false;
                            }),
                            negative: (({
                                modal,
                            }) => {
                                modal.close();
                                this.isCommit = false;
                            }),
                            buttons: ['itemHolds.converttocrv', 'common.cancel'],
                            type: 'success'
                        })
                        return;
                    }
                    // Make a single service call with children array and unfit denominations
                    this.AtmResidualService.ResidualCountCommit(
                        this.model.locationId.Id,
                        this.model.branch,
                        pickupDate,
                        pickupTime,
                        this.branchTimeZone,
                        this.model.loggedInUserId,
                        children,
                        parentResidual,
                        supId,
                        unfitDenomsData,
                        this.monthlySupId,
                        this.monthlyLimitDetails ? this.monthlyLimitDetails.monthlyCashCountLimitAmount : 0,
                        this.monthlyLimitDetails ? this.monthlyLimitDetails.totalCountedThisMonth : 0,
                        this.monthlyLimitDetails ? this.monthlyLimitDetails.newCountAmount : 0
                    )
                        .then((data) => {
                            this.successCount += data.successfulCommits;
                            this.bagCount();
                            if (addDeposit) {
                                return this.AtmResidualDepositService.createResidualDepositShipment(
                                    parentResidual.trackingId
                                ).then((depositShipment) => {
                                    this.updateData();
                                    this.model.bagId = depositShipment.trackingId;
                                    this.loadShipmentByTrackingId();
                                    this.isCommit = false;
                                    defer.resolve(data);
                                }).catch((err) => {
                                    this.updateData();
                                    this.model.bagId = this.lastScanned;
                                    this.loadShipmentByTrackingId();
                                    this.isCommit = false;
                                    const message = err && err.data && err.data.message
                                        ? err.data.message
                                        : (err && err.message ? err.message : 'Unable to create the deposit shipment.');
                                    this.Modal.errorModal(message);
                                    defer.reject(err);
                                });
                            }

                            this.isCommit = false;
                            this.updateData();
                            this.model.bagId = this.lastScanned;
                            this.loadShipmentByTrackingId();
                            defer.resolve(data);
                        })
                        .catch((err) => {
                            this.isCommit = false;
                            if (err && err.data && err.data.message && err.data.message != "93751") {
                                this.Sound.PlayErrorBeep("#scanner_beep");
                                this.Modal.errorModal('error.' + err.data.message);
                            }
                            else if (err && err.data && err.data.message && err.data.message == "93751") {
                                this.Sound.PlayErrorBeep("#scanner_beep");
                                const message = this.$translate.instant('error.' + err.data.message, {
                                    amount: this.totalResidualAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                });
                                this.Modal.errorModal(message);
                            }
                            defer.reject(err);
                        });
                } else {
                    this.atmResidualRecord.comment = comments;
                    return this.residualCountEdit(children, parentResidual, comments, supId);
                }

                this.isPressExpectedResidualButton = true;
            }).catch((err) => {
                this.isPressExpectedResidualButton = false;
                this.isCommit = false;
            })

            return defer.promise;
        // });
    }
    
    confirmUpdateShipment() { // user confirmation before update `shipment.orderType`
        this.isCommit = true;
        
        const defer = this.$q.defer(), 
              message = (this.model.expectedResidualToSend > 0 && this.model.expectedResidualTotal !== this.model.crvTotal) ? 
                        'atm_residual.warning' : 
                        'atm_residual.total_cash_count.warning';        

        this.Modal.confirm({
            header: this.$translate.instant('common.confirm_title'),
            message: this.$translate.instant(message),
            callback: (({
                modal,
                $scope
            }) => {
                this.isCommit = true;
                this.updateOrderType() // call when confirmed
                    .then((data) => {
                        this.isCommit = false;
                        defer.resolve(data)
                    })
                    .catch((err) => {
                        this.isCommit = false;
                        defer.reject(err)
                    })
                modal.close();
            }),
            negative: (({
                modal,
            }) => {
                this.isCommit = false;
                modal.close();
            }),
            type: 'danger'
        })
        return defer.promise
    }
    
    updateOrderType() { // find matching reacords form ATMRESIDUAL and update `shipment.orderType` for both residual and load shipments
        let orderNo = this.atmResidualRecord.orderNo,
            deliveryShipmentId = this.atmResidualRecord.deliveryShipmentId,
            residualShipmentId = this.atmResidualRecord.residualShipmentId;
        const defer = this.$q.defer();
        this.AtmResidualService.findAtmResidualRecord(orderNo, deliveryShipmentId, residualShipmentId)
            .then((data) => {
                defer.resolve(data)
            })
            .catch((err) => {
                this.isCommit = false;
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal('error.' + err.data.message)
                }
                defer.reject(err)
            })
        return defer.promise
    }
    
    goToOrderHistory(data) {
        let isPending = !this.model.parentAtmResidual.packedFlag;
        let isCounted = this.model.parentAtmResidual.finishedAt;
        let fundingSourceId = this.model.locationId ? this.model.locationId.Id : null;
        this.Navigation.goToOrderHistory(this.atmResidualRecord.orderNo, this.model.vaultDate, true, isCounted, null, isPending, null, fundingSourceId);
    }
    
    goToServiceHistory(data) {
        this.Navigation.goToServiceHistory(this.fromLocationId, null, true, null)
    }
    
    calculateAmount(index) {
        let data = this.model.atmResidual[index];  // current child data
        let atmResidual = this.model.atmResidual[index];
        let parentData = this.model.parentAtmResidual;  // parent data for comparison

        // Initialize child values, using 0 if undefined
        let expectedResidual = data.expectedResidual || 0;
        let requestLoad = data.requestLoad || 0;
        let actualLoad = data.actualLoad || 0;
        let countedResidual = data.countedResidual || 0;
        let madeCRV = data.madeCRV || 0;

        let transferredAmount = data.transferredAmount || 0;
        let dispensedAmount = data.dispensedAmount || 0;

        // Initialize parent values, using 0 if undefined
        let parentRequestLoad = parentData ? parentData.requestLoad || 0 : 0;
        let parentExpectedResidual = parentData ? parentData.expectedResidual || 0 : 0;
        let parentActualLoad = parentData ? parentData.actualLoad || 0 : 0;

        // Calculate for current child row (atmResidual) based on parent restrictions
        if (atmResidual.finishedAt && atmResidual.crv != null && !this.isEdit) {
            data.actualLoad = Number((requestLoad - atmResidual.crv).toFixed(4));
        } else if (atmResidual.finishedAt && data.actualLoad === "") {
            data.actualLoad = 0;
        } else {
            actualLoad = data.actualLoad || 0;
        }

        if (atmResidual.finishedAt && data.expectedResidual === "") {
            data.expectedResidual = 0;
        } else {
            expectedResidual = data.expectedResidual || 0;
        }

        let divisor = (atmResidual.coinPackaging === 'ROLLED' || atmResidual.coinPackaging === 'INDIVIDUAL') && atmResidual.unitValue
            ? atmResidual.unitValue
            : atmResidual.faceValue;

        divisor = divisor || 1;

        atmResidual.denomActualLoad = Number((actualLoad / divisor).toFixed(4)).toLocaleString();
        atmResidual.denomExpectedResidual = Number((expectedResidual / divisor).toFixed(4)).toLocaleString();
        atmResidual.denomCountedResidual = Number((countedResidual / divisor).toFixed(4)).toLocaleString();

        // Calculate CRV and variance
        let loadAmount = atmResidual.actualLoad || 0;
        let expectedResidualAmount = atmResidual.expectedResidual || 0;
        let countedResidualAmount = atmResidual.countedResidual || 0;
        let priorLoadAmount = atmResidual.actualPriorLoad || atmResidual.manualPriorLoadAmount || 0;

        if (atmResidual.finishedAt && atmResidual.crv != null && !this.isEdit) {
            atmResidual.crv;
        } else if (atmResidual.finishedAt && (atmResidual.crv === '' || atmResidual.crv === undefined) && !loadAmount) {
            atmResidual.crv = 0;
        } else {
            atmResidual.crv = Number((requestLoad - loadAmount).toFixed(4));
        }

        if (madeCRV) {
            atmResidual.variance = Number((atmResidual.crv - countedResidualAmount).toFixed(4));
        }
        else if (priorLoadAmount == 0 && atmResidual.crv === 0) {
            atmResidual.variance = 0;
        }
        else {
            atmResidual.variance = Number((countedResidualAmount - expectedResidualAmount).toFixed(4));
        }

        data.denomTransferredAmount = Number((transferredAmount / divisor).toFixed(4)).toLocaleString();
        data.denomDispensedAmount = Number((dispensedAmount / divisor).toFixed(4)).toLocaleString();
        // If all validations pass, reset error and update totals
        this.isError = false;
        this.totalAmount();
    }

    calculateFromBillCount(index, denomField, amountField) {
        let data = this.model.atmResidual[index];
        if (!data) return;

        let divisor = (data.coinPackaging === 'ROLLED' || data.coinPackaging === 'INDIVIDUAL') && data.unitValue
            ? data.unitValue
            : data.faceValue;
        divisor = divisor || 1;

        let countRaw = data[denomField];
        let count = countRaw ? Number(String(countRaw).split(",").join('')) : 0;

        data[amountField] = Number((count * divisor).toFixed(4));

        this.calculateAmount(index);

        let calculatedCount = Number((data[amountField] / divisor).toFixed(4));
        if (count === calculatedCount || (countRaw === '' && calculatedCount === 0)) {
            data[denomField] = countRaw;
        }
    }

    setFocus(event) {
        this.focusElementById('residual-commit')
    }

    // Reset totalAmount
    resetTotal() {
        this.model.actualLoadTotal = 0;
        this.model.crvTotal = 0;
        this.model.expectedResidualTotal = 0;
        this.model.dispensedAmountTotal = 0;
        this.model.transferredAmountTotal = 0;
        this.model.countedResidualTotal = 0;
        this.model.varianceTotal = 0;
        this.shipmentLoading = false;
    }

    // Display sum of all cell value
    totalAmount() {
        this.model.actualLoadTotal = 0;
        this.model.crvTotal = 0;
        this.model.expectedResidualTotal = 0;
        this.model.countedResidualTotal = 0;
        this.model.dispensedAmountTotal = 0;
        this.model.transferredAmountTotal = 0;
        this.model.varianceTotal = 0;
        this.model.varianceToSend = 0;
        this.model.cashReturnedVaultToSend = 0;
        this.model.expectedResidualToSend = 0; 

        this.model.atmResidual.forEach((residualRecord) => {
            this.model.actualLoadTotal += residualRecord.actualLoad ? residualRecord.actualLoad : 0;
            this.model.crvTotal += residualRecord.crv ? residualRecord.crv : 0;
            this.model.expectedResidualTotal += residualRecord.expectedResidual ? residualRecord.expectedResidual : 0;
            this.model.countedResidualTotal += residualRecord.countedResidual ? residualRecord.countedResidual : 0;
            this.model.dispensedAmountTotal += residualRecord.dispensedAmount ? residualRecord.dispensedAmount : 0;
            this.model.transferredAmountTotal += residualRecord.transferredAmount ? residualRecord.transferredAmount : 0;
            this.model.varianceTotal += residualRecord.variance ? residualRecord.variance : 0;
            this.model.expectedResidualToSend += Number(residualRecord.denomExpectedResidual.split(",").join(''));
            
            let divisor = (residualRecord.coinPackaging === 'ROLLED' || residualRecord.coinPackaging === 'INDIVIDUAL') && residualRecord.unitValue
                ? residualRecord.unitValue
                : residualRecord.faceValue;

            // prevent division by zero in case of bad data
            divisor = divisor || 1;

            this.model.cashReturnedVaultToSend += Number((residualRecord.crv / divisor).toFixed(4));
            this.model.varianceToSend += Number((residualRecord.variance / divisor).toFixed(4));
        });

        if (this.model.parentAtmResidual) this.model.parentAtmResidual.actualLoad = this.model.actualLoadTotal; 
        if (this.model.parentAtmResidual) this.model.parentAtmResidual.crv = this.model.crvTotal;
        this.model.countedResidualTotalDisplay = (Number(this.model.countedResidualTotal) || 0) + (Number(this.model.unfitTotalCashCounted) || 0);
    }

    commitDisabled(index) {
        let shouldDisabled = false;
        let isValidPriorLoadAmount = false;
        let totalValidActualLoad = 0,
            totalValidCountedResidual = 0,
            totalValidExpectedResidual = 0;

        for (let i = 0; i < this.model.atmResidual.length; i++) {
            let data = this.model.atmResidual[i];
            let isWrong = this.validateResidualData(data);
            if (isWrong) shouldDisabled = true;

            totalValidActualLoad += Number(data.actualLoad) || 0;
            totalValidCountedResidual += Number(data.countedResidual) || 0;
            totalValidExpectedResidual += Number(data.expectedResidual) || 0;
        }

        totalValidActualLoad = Number(totalValidActualLoad.toFixed(4));
        totalValidCountedResidual = Number(totalValidCountedResidual.toFixed(4));
        totalValidExpectedResidual = Number(totalValidExpectedResidual.toFixed(4));

        if (this.hasUnfitDenoms() && this.shiptype === 'residual') {
            const unfitValidationFailed = this.validateUnfitDenominations();
            if (unfitValidationFailed) shouldDisabled = true;
        }

        if (this.expectedResidualDetails && this.expectedResidualDetails.length > 0) {
            isValidPriorLoadAmount = this.expectedResidualDetails.some(d => !d.isValidAmount && d.manualPriorLoadAmount >= 0);
        }

        let parentActualLoad = this.model.parentAtmResidual.actualLoad != null ? Number(Number(this.model.parentAtmResidual.actualLoad).toFixed(4)) : 0;

        if (this.model.parentAtmResidual.actualLoad == null || parentActualLoad < totalValidActualLoad) {
            shouldDisabled = true;
        }

        return shouldDisabled || isValidPriorLoadAmount;
    }

    isActualLoadExceedsRequestLoad(data) {
        if (data && data.actualLoad !== "" && data.actualLoad != null && data.requestLoad !== "" && data.requestLoad != null) {
            return Number(data.actualLoad) > Number(data.requestLoad);
        }
        return false;
    }

    validateResidualData(data) {
        let countPattern = /^([0-9][0-9 _ ,]*)?(\.[0-9]+)?$/;
        let amountPattern = /^-?([0-9][0-9 _ ,]*)?(\.[0-9]+)?$/;

        let isValidActualLoad = countPattern.test(data.denomActualLoad !== null && data.denomActualLoad !== undefined ? String(data.denomActualLoad) : "invalid"),
            isValidExpectedResidual = countPattern.test(data.denomExpectedResidual !== null && data.denomExpectedResidual !== undefined ? String(data.denomExpectedResidual) : "invalid"),
            isValidCountedResidual = countPattern.test(data.denomCountedResidual !== null && data.denomCountedResidual !== undefined ? String(data.denomCountedResidual) : "invalid"),
            isValidTransferredAmount = countPattern.test(data.denomTransferredAmount !== null && data.denomTransferredAmount !== undefined ? String(data.denomTransferredAmount) : "invalid"),
            isValidDispensedAmount = countPattern.test(data.denomDispensedAmount !== null && data.denomDispensedAmount !== undefined ? String(data.denomDispensedAmount) : "invalid"),
            isValidCRV = amountPattern.test(data.crv !== null && data.crv !== undefined ? String(data.crv) : "invalid");

        let isDisabled = (data.actualLoad !== "" && data.actualLoad >= 0 &&
            data.countedResidual !== "" && data.countedResidual >= 0 &&
            data.expectedResidual !== "" && data.expectedResidual >= 0) || 'isEmpty';

        let isWrong = isDisabled === 'isEmpty' ||
            isValidActualLoad === false ||
            isValidExpectedResidual === false ||
            isValidCountedResidual === false ||
            isValidCRV === false ||
            data.isLoadShipmentIsOnHold ||
            !this.pickupDate ||
            !this.model.beginTime ||
            isValidTransferredAmount === false ||
            isValidDispensedAmount === false ||
            this.isActualLoadExceedsRequestLoad(data) ||
            data.transferredAmount === undefined ||
            data.dispensedAmount === undefined;

        return isWrong;
    }

    validateUnfitDenominations() {
        const unfitDenoms = this.getViewUnfitDenominations();
        let hasValidationErrors = false;

        // Pattern to validate whole numbers only (no decimals)
        const wholeNumberPattern = /^[0-9]\d*(\,\d+)?$/;

        unfitDenoms.forEach(denom => {
            const amount = Number(denom.totalCashCounted) || 0;
            const faceValue = Number(denom.faceValue) || 0;

            // Skip validation if amount is 0 or empty
            if (amount === 0) return;

            if (faceValue > 0) {
                const billCount = amount / faceValue;
                const billCountString = billCount.toLocaleString();

                // Validate that the bill count is a whole number
                if (!wholeNumberPattern.test(billCountString) || billCount !== Math.floor(billCount)) {
                    hasValidationErrors = true;
                }
            }
        });

        return hasValidationErrors;
    }

    expectedResidualDisabled(index) {
        let shouldDisabled = false;
        let totalValidActualLoad = 0,
            totalValidCountedResidual = 0,
            totalValidExpectedResidual = 0;
        for (let i = 0; i < this.model.atmResidual.length; i++) {
            let data = this.model.atmResidual[i];
            let isWrong = this.expectedResidualData(data);
            if (isWrong) shouldDisabled = true;
            totalValidActualLoad += Number(data.actualLoad);
            totalValidCountedResidual += Number(data.countedResidual);
            totalValidExpectedResidual += Number(data.expectedResidual);
        }
        return shouldDisabled;
    }

    expectedResidualData(data) {
        let patterns = /^-?\d+$/,
            isValidActualLoad = patterns.test(data.denomActualLoad),
            isValidExpectedResidual = patterns.test(data.denomExpectedResidual),
            isValidCountedResidual = patterns.test(data.denomCountedResidual),
            isValidTransferredAmount = patterns.test(data.denomTransferredAmount),
            isValidDispensedAmount = patterns.test(data.denomDispensedAmount),
            isValidCRV = patterns.test(data.crv);

        let isDisabled = (
            data.actualLoad !== "" && data.actualLoad !== undefined && data.actualLoad !== null
            && data.countedResidual !== "" && data.countedResidual !== undefined && data.countedResidual !== null
            // && data.expectedResidual !== "" && data.expectedResidual !== undefined && data.expectedResidual !== null
        ) || 'isEmpty';

        let isWrong = (
            isDisabled === 'isEmpty' ||
            isValidActualLoad === false ||
            isValidExpectedResidual === false ||
            isValidCountedResidual === false ||
            isValidCRV === false ||
            data.isLoadShipmentIsOnHold ||
            !this.pickupDate ||
            !this.model.beginTime ||
            isValidTransferredAmount === false ||
            isValidDispensedAmount === false
        );

        return isWrong;
    }

    // Make cells nonEditable if bagId not match with trackingId
    disableRow(index, isParent = false) {
        if (this.lastScanned) {
            return this.model.parentAtmResidual.trackingId.toUpperCase() !== this.lastScanned.toUpperCase() 
                    || this.model.parentAtmResidual.finishedAt;
        }
        return false;
    }

    // Hide commint button if bagId not match with trackingId
    showCommit(index) {
        if (this.lastScanned) return this.model.atmResidual[index].trackingId.toUpperCase() === this.lastScanned.toUpperCase();
    }

    // get residual bag counts 
    bagCount(focusTrackingId) {
        if (!this.model.locationId) {
            return this.shipmentData = [];
        }
        return this.AtmResidualService.getResidualBagCount(this.model.locationId.Id, this.model.branch)
            .then((data) => {
                this.remainingResiduals = data;
                this.remainingResidualBag = data.result.length;
                this.model.depositRecord.denominations = this.allDenominations.filter((o)=> o.currencyId===this.model.locationId.currencyId);
                this.setCurrencySymbol();
                if (focusTrackingId) this.focusElementById('trackingId');
            })
            .catch((err) => {
                console.log(err);
            })
    }

    // show remaining residual shipment to be counted
    residualBag() {
        this.Modal.remainingResiduals(this.remainingResiduals, this.model.locationId, this.model.branch, ({ modal, trackingId }) => {
            this.model.bagId = trackingId;
            this.loadShipmentByTrackingId();
            modal.close();
        }, ({ modal }) => {
            modal.close();
        })
    }

    getOrderType(type) {
        switch (type) {
            case type: return this.$translate.instant('atm_residual.order_type_' + type);
            default: return '';
        }
    }

    scanSuffix() {
        if (this.enterSuffix.length > 0 && this.model.bagId.endsWith(this.enterSuffix)) {
            const bagIdLength = this.model.bagId.length;
            this.model.bagId = this.model.bagId.slice(0, bagIdLength - this.enterSuffix.length)
        }
    }

    // Load shipments based on orderNo
    loadShipments() {
        if (this.shipmentLoading || !this.model.locationId) return;
        this.successCount = 0;
        this.finishedAt = null;
        this.expectedResidualDetails = [];
        this.isEdit = false;

        if (this.model.bagId === undefined) {
            return this.shipmentData = [];
        }
        this.shipmentLoading = true;
        this.model.requestLoadTotal = 0;
        this.lastScanned = this.model.bagId;
        this.AtmResidualService.getResidualShipments(this.model.bagId, this.model.locationId.Value)
        .then((data) => {
            // Initialize/reset variables
            this.model.atmResidual = [];
            this.model.parentAtmResidual = null;
            this.parentShipment = null;
            this.isError = false;
            this.shipmentData = data;

            // Separate parent and child shipments
            this.childShipmentData = data.filter(d => d.bagSeal !== null);
            let parentShipments = data.filter(d => d.bagSeal === null);

            // Map parent shipment if exists
            if (parentShipments && parentShipments.length > 0) {
                this.parentShipment = parentShipments[0];
                this.fromLocationId = this.parentShipment.fromLocationId;
                this.orderType = this.parentShipment.orderType;
                this.model.parentAtmResidual = this.mapShipmentToModel(this.parentShipment, true);
                this.findShipmentToCommit(this.parentShipment, 0);
                this.model.parentAtmResidual.parentStatedAmount = this.parentShipment && this.parentShipment.amount ? this.parentShipment.amount : 0;
            }

            // Map each child shipment
            this.childShipmentData.forEach((data, index) => {
                const mappedShipment = this.mapShipmentToModel(data);
                this.model.atmResidual[index] = mappedShipment;
                this.model.requestLoadTotal += mappedShipment.requestLoad;
                this.originalCountAmount += (parseFloat(data.amountCounted) || 0);
                
                this.fromLocationId = data.fromLocationId;
                this.fromLocationName = data.fromLocationName;
                this.isEmergencyType = data.isEC;
                this.isLoadShipmentIsOnHold = data.isLoadShipmentIsOnHold;

                this.finishedAt = mappedShipment.finishedAt;
                if (this.finishedAt) this.isEdit = false;
                if (data.notes) this.atmResidualRecord.notes = data.notes;

                this.calculateAmount(index); 
            });
            this.calculateAmountForParent();
        })
        .then(() => {
            this.resetTotal();
        })
        .then(() => {
            this.totalAmount();
            if (this.shipmentData.length) return this.focusElementById('counted-residual');
        })
        .then(() => {
            if (this.locationData) {
                this.locationData.isRedirected = false;
                this.locationData = this.DataCounter.setData();
            }
            this.validateResidualCountEdit();
            this.model.cloneAtmResidual = _.cloneDeep(this.model.atmResidual);
            this.initializeUnfitDenominations();
            this.restorePreviousUnfitDenominations()
        })
        .then(() => this.getExpectedResidual())
        .catch((err) => {
            this.shipmentLoading = false;
            console.log(err);
            this.Modal.errorModal(err.data.message);
        }); 
    }

    checkMonthlyCountLimit(newAmount, shiptype = this.shiptype) {
        let deferred = this.$q.defer();
        
        const locId = this.fromLocationId;
        if (!locId) {
            deferred.resolve();
            return deferred.promise;
        }

        // Determine if this is an edit and get the corresponding shipment's vault date
        let isEdit = false;
        const type = (shiptype || '').toLowerCase();
        if (type === 'deposit' || type === 'cod' || type === 'bulkcash') {
            isEdit = this.showEditDepositButton() || !!this.isEdit;
        } else if (type === 'bulkdeposit') {
            isEdit = !!(this.activeBagData && (this.activeBagData.isEditMode || (this.activeBagData.bagIndex !== null && this.canEditBag(this.activeBagData.bagIndex))));
        } else if (type === 'residual' || type === 'c') {
            isEdit = !!(this.shipmentData.length && this.model.locationId && this.hasACL['atm_count'] && this.hasACL['atm_count']['editCommitted'] && this.finishedAt) || !!this.isEdit;
        }
        
        // Delta Calculation: Pass the difference during edit, otherwise pass full newAmount for first-time count.
        const deltaAmount = isEdit ? (newAmount - (this.originalCountAmount || 0)) : newAmount;

        // Determine the month: prioritize the branch's global vault date
        const activeVaultDate = this.model.vaultDate ;
        const monthName = activeVaultDate ? moment(activeVaultDate).format('MMMM') : moment().format('MMMM');

        this.AtmResidualDepositService.getMonthlyCountCheck(locId, deltaAmount, this.model.branch, monthName, shiptype)
            .then((result) => {
                if (result && result.wouldExceed) {
                    const sym = this.currencySymbol || '$';
                    const fmt = (v) => sym + Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    const limitAmt   = result.monthlyCashCountLimitAmount;
                    const counted    = result.totalCountedThisMonth;
                    const current    = result.newCountAmount;
                    const newTotal   = counted + current;
                    const exceedBy   = newTotal - limitAmt;

                    this.monthlyLimitDetails = {
                        monthlyCashCountLimitAmount: limitAmt,
                        totalCountedThisMonth: counted,
                        newCountAmount: current
                    };

                    this.Modal.confirm({
                        header: 'Monthly Cash Count Limit Exceeded',
                        message: `
                            <div style="line-height:1.8">
                                <p>Count will Exceed Monthly Count Threshold. Do you Wish to Proceed?</p>
                            </div>`,
                        callback: ({ modal }) => {
                            if (modal) modal.close();
                            this.Modal.confirmSupervisor('monthly-cash-count-limit-exceeded', null, ({ modal: supModal, supId }) => {
                                if (supModal) supModal.close();
                                this.monthlySupId = supId; 
                                deferred.resolve(supId);
                            }, ({ modal: supModal }) => {
                                if (supModal) supModal.close();
                                deferred.reject();
                            }, 'modal-top-offset');
                        },
                        negative: ({ modal }) => {
                            if (modal) modal.close();
                            deferred.reject();
                        },
                        buttons: ['common.ok', 'common.cancel'],
                        type: 'success',
                    });
                } else {
                    deferred.resolve();
                }
            })
            .catch((err) => {
                console.error("Monthly Count Check failed:", err);
                deferred.resolve();
            });
            
        return deferred.promise;
    }

    commitDeposit() {
        this.isCommit = true;
        this.monthlySupId = null; 

        let newAmount = this.model.depositRecord.totalAmount || 0;
        this.checkMonthlyCountLimit(newAmount).then(() => {
            let countedVariance = this.model.depositRecord.countedVariance || 0;
            if (countedVariance !== 0) {
                this.Modal.residualComments({ trackingId: this.model.bagId }, ({ modal, comments }) => {
                    this._executeDepositCommit(comments);
                }, ({ modal }) => {
                    this.isCommit = false;
                    modal.close();
                });
            } else {
                this._executeDepositCommit(null);
            }
        }).catch(() => {
            this.isCommit = false;
        });
    }

    _executeDepositCommit(comment) {
        let denomsData = this.model.depositRecord.denominations.map((denom, _) => {
            return {
                denominationId: denom.id,
                quantity: Number(denom.totalCounted)
            }
        })
       
        let fundingSource = this.model.locationId.Id,
            trackingId = this.model.bagId,
            branchId = this.model.branch,
            pickupDate = moment(this.pickupDate).format('YYYY-MM-DD'),
            pickupTime = moment(this.model.beginTime).format('HH:mm:ss'),
            branchTimeZone = this.branchTimeZone,
            countedByUserId = this.model.loggedInUserId,
            declaredTotalAmount = this.model.depositRecord.declaredTotalAmount,
            countedVariance = this.model.depositRecord.countedVariance

        this.checkSupervisorApproval(countedVariance).then((supId) => { 
            const hasExistingDepositRecord = this.model.depositRecord && 
                                            this.model.depositRecord.depositRecord && 
                                            this.model.depositRecord.depositRecord.id;
            const isEditOperation = hasExistingDepositRecord || 
                                   this.finishedAt || 
                                   (this.isEdit && hasExistingDepositRecord) ||
                                   this.successCount > 0;
            
            if (isEditOperation && hasExistingDepositRecord) {
                // Use edit API when there's an existing deposit record
                this.AtmResidualDepositService.editDepositCount(
                    fundingSource, trackingId, comment, denomsData, branchId, pickupDate, pickupTime, branchTimeZone, countedByUserId, 
                    this.model.depositRecord.depositRecord.id, declaredTotalAmount, countedVariance, supId, this.browserTimezone, this.monthlySupId, this.monthlyLimitDetails ? this.monthlyLimitDetails.monthlyCashCountLimitAmount : 0, this.monthlyLimitDetails ? this.monthlyLimitDetails.totalCountedThisMonth : 0, this.monthlyLimitDetails ? this.monthlyLimitDetails.newCountAmount : 0, this.model.depositRecord.notes || null
                ).then((data) => {
                    this.model.depositRecord.previousDenominations = _.cloneDeep(this.model.depositRecord.denominations);
                    this.isCommit = false;
                    this.isEdit = false;
                    this.loadDepositShipment();
                    this.updateDepositData(data);
                    this.validateDepositCountEdit();
                }).catch((err) => {
                    this.isCommit = false;
                    if (err && err.data && err.data.message) {
                        this.Sound.PlayErrorBeep("#scanner_beep");
                        const raw = String(err.data.message || '');
                        if (raw.startsWith('E_NEGATIVE_FINAL_LEDGER|')) {
                            const csv = raw.split('|')[1] || '';
                            const text = `This change would make the ledger balance negative for (${csv}).`;
                            this.Modal.errorModal(text);
                        } else {
                            this.Modal.errorModal('error.' + raw);
                        }
                    }
                })
            } else {
                this.AtmResidualDepositService.commitDepositCount(
                    fundingSource, trackingId, comment, denomsData, branchId, pickupDate, pickupTime, branchTimeZone, countedByUserId, declaredTotalAmount, countedVariance, supId, this.browserTimezone, this.monthlySupId, this.monthlyLimitDetails ? this.monthlyLimitDetails.monthlyCashCountLimitAmount : 0, this.monthlyLimitDetails ? this.monthlyLimitDetails.totalCountedThisMonth : 0, this.monthlyLimitDetails ? this.monthlyLimitDetails.newCountAmount : 0, this.model.depositRecord.notes || null
                ).then((data) => {
                    this.isCommit = false;
                    this.isEdit = false;
                    this.successCount++;
                    this.updateDepositData(data);
                    this.validateDepositCountEdit();
                    this.model.bagId = this.lastScanned;
                    if (this.isCODShipment()) {
                        this.bagCount();
                        return this.loadDepositShipment();
                    }
                    this.bagCount();
                    this.loadShipmentByTrackingId();
                }).catch((err) => {
                    this.isCommit = false;
                    if (err && err.data && err.data.message) {
                        this.Sound.PlayErrorBeep("#scanner_beep");
                        const raw = String(err.data.message || '');
                        if (raw.startsWith('E_NEGATIVE_FINAL_LEDGER|')) {
                            const csv = raw.split('|')[1] || '';
                            const text = `This change would make the ledger balance negative for (${csv}).`;
                            this.Modal.errorModal(text);
                        } else {
                            this.Modal.errorModal('error.' + raw);
                        }
                    }
                })
            }
        }).catch((err) => {
            this.isCommit = false;
        })
    }

    checkSupervisorApproval(conditionValue) {
        let deferred = this.$q.defer();
    
        if (this.model.locationId && this.model.locationId.varianceCheckEnabled && (Math.abs(conditionValue) > this.model.locationId.varianceThreshold)) {
            this.Modal.confirmSupervisor('variance-threshold-exceeded', null, ({ modal, supId }) => {
                modal.close();
                deferred.resolve(supId);
            }, ({ modal }) => {
                modal.close();
                deferred.reject();
            });
        } else {
            deferred.resolve(this.monthlySupId || null);
        }
    
        return deferred.promise;
    }

    resetDepositCommit() {
        this.model.depositRecord.depositRecord = null;
        let denominations = this.model.depositRecord.denominations.map((denom) => {
            return {
                ...denom,
                totalCounted: 0,
                totalValue: 0
            }
        });
        
        
        this.model.depositRecord.denominations = denominations;
        this.model.depositRecord.totalAmount = 0;
        this.model.depositRecord.countedVariance = 0; 
        this.model.depositRecord.declaredTotalAmount = 0;
        this.model.depositRecord.notes = '';
        this.model.depositRecord.previousNotes = '';
    }

    loadShipmentByTrackingId() {
        if (this.shipmentLoading || !this.model.locationId || !this.model.bagId) return;
        this.shipmentLoading = true;
        this.lastScanned = this.model.bagId;
        this.finishedAt = null;
        this.successCount = 0;
        this.fromLocationId = null;
        this.fromLocationName = null;
        this.originalCountAmount = 0;
        
        const fundingSourceId = this.model.locationId ? this.model.locationId.Id : null;
        this.ShipmentService.updateShipmentCountStatus(this.model.bagId, this.model.locationId.Value, fundingSourceId).then((data) => {
            this.shipmentLoading = false;
            
            if (data && data.pickupFlag === true) {
                if (data.shiptypeId === 'C') {
                    this.isBagout = false;
                    this.shiptype = 'residual';
                    this.isBulkDeposit = false;
                    this.resetBulkDepositData();
                    this.loadShipments()
                } else if (data.shiptypeId === 'BULKDEPOSIT') {
                    this.isBagout = false;
                    this.shiptype = 'bulkdeposit';
                    this.isBulkDeposit = true;
                    this.loadBulkDepositShipment()
                } else {
                    this.isBagout = false;
                    this.shiptype = 'deposit'; 
                    this.isBulkDeposit = false;
                    this.resetBulkDepositData();
                    this.loadDepositShipment()
                }
            }
            if (data && data.isBagout === true && data.deleted == false) {
                this.isBagout = true;
                this.isBulkDeposit = false;
                this.resetBulkDepositData();
                this.loadBagoutcontent();
            }
            this.toggleTab();
        }).catch((err) => {
            this.model.depositRecord.depositShipment = null;
            this.shipmentData = [];
            this.shipmentLoading = false;
            this.isBagout = false;

            if (err.data && err.data.message && err.data.message.startsWith('COUNTING_ORDER_VIOLATION:')) {
                const requiredTrackingId = err.data.message.split(':')[1];
                this.Modal.errorModal(`Please count ${requiredTrackingId} first.`);
            } else {
            this.Modal.errorModal("error." + err.data.message);
            }
        })
        .finally(() => {
            this.isPressExpectedResidualButton = false;
        })
    }

    loadBagoutcontent() {
        setTimeout(()=>{
            this.Modal.verifyBagoutCashCount(this.model.bagId, this.model.locationId.Id, this.model.branch, ({ modal }) => {
                this.bagCount();
            }, ({ modal }) => {
                modal.close();
            })
        },300)
    }

    loadDepositShipment() {
        if (this.shipmentLoading || !this.model.locationId || !this.model.bagId) return;
        this.shipmentLoading = true;
        this.lastScanned = this.model.bagId;
        this.finishedAt = null;

        this.AtmResidualDepositService.getDepositShipmentRecord(this.model.bagId, this.model.locationId.Value)
        .then((data) => {
            this.shipmentLoading = false;
            this.fromLocationId = data.shipmentRecord.fromLocationId;
            this.fromLocationName = data.shipmentRecord.fromLocation.name;
            this.model.depositRecord.depositShipment = data.shipmentRecord;
            this.model.depositRecord.depositRecord = data.depositRecord;
            this.model.depositRecord.statedTotalAmount = data.shipmentRecord.amount || 0;
            
            this.codFlags = {
                isPackable: data.shipmentRecord.isPackable || false,
                isCRVed: data.shipmentRecord.isCRVed || false,
                includedDenominationIds: data.shipmentRecord.includedDenominationIds || []
            };
            this.setCountRestrictionFromShipment(data.shipmentRecord);
            if (data.depositRecord) {
                this.originalCountAmount = data.depositRecord.totalAmount || 0;
                this.finishedAt = data.depositRecord.countedAt;
                this.isEdit = false;
                this.pickupDateTime(data.depositRecord.pickupDate);
                this.model.depositRecord.countedVariance = data.depositRecord.countedVariance || 0;
                this.model.depositRecord.declaredTotalAmount = data.depositRecord.declaredTotalAmount;
                this.model.depositRecord.totalVariance = data.depositRecord.totalVariance || 0;
                this.model.depositRecord.denominations = this.denomsDataUpdate(data.depositRecord.denominations);
                this.model.depositRecord.previousDenominations = _.cloneDeep(this.model.depositRecord.denominations);
                this.model.depositRecord.notes = data.depositRecord.notes || '';
                this.model.depositRecord.previousNotes = this.model.depositRecord.notes;
                this.isBulkCash = false;
            } else if(data.shipmentRecord && data.shipmentRecord.countCompletedAt && data.shipmentRecord.shiptypeId === 'BULKCASH') {
                this.finishedAt = data.shipmentRecord.countCompletedAt;
                this.isEdit = false;
                this.isBulkCash = true;
                this.resetDepositCommit();
                this.pickupDateTime(data.shipmentRecord.pickupDate);
            }
            else {
                this.isEdit = true;
                this.resetDepositCommit();
            }
            this.depositCountTotal();
            this.pickupDateTime(data.shipmentRecord.pickupDate);
            this.model.depositRecord.totalDeposit = data.shipmentRecord.amount || 0;
            this.validateDepositCountEdit();
        })
        .catch((err) => {
            console.error(err);
            if(err.data.message) this.Modal.errorModal(err.data.message);
            this.shipmentLoading = false;
        })
    }

    updateDepositData() {
        this.finishedAt = moment().format('MM-DD-YYYY | h:mm A'); 
        this.model.bagId = "";
        this.isEdit = false;
        this.model.depositRecord.previousNotes = this.model.depositRecord.notes || '';
        this.focusElementById('trackingId'); 
    }

    validateDepositCountEdit() {
        this.isSameVaultDate = true;
        return this.AtmResidualService.getVaultDate(this.model.branch, this.lastScanned)
            .then((data) => {
                let shipmentVaultDate = new Date(data.shipmentVaultDate);
                let branchCurrentVaultDate = new Date(data.branchCurrentVaultDate);
                if (this.model.locationId && !this.model.locationId.EditCountAnytime) this.isSameVaultDate = shipmentVaultDate.getUTCDate() === branchCurrentVaultDate.getUTCDate();
                else if (this.model.locationId && this.model.locationId.EditCountAnytime) this.isSameVaultDate = true;
                if(this.isBulkCash){
                    this.allowBulkCashEdit = shipmentVaultDate.getUTCDate() === branchCurrentVaultDate.getUTCDate();
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }

    showDepositCommit() {
        if (this.lastScanned) return this.model.depositRecord.depositShipment.trackingId.toUpperCase() === this.lastScanned.toUpperCase();
    }
    // find matching records 
    findShipmentToCommit(shipmentData, index) {
        if (this.model.parentAtmResidual.trackingId.toUpperCase() == this.lastScanned.toUpperCase()) {
            this.atmResidualRecord = {
                deliveryShipmentId: shipmentData.deliveryShipmentId,
                residualShipmentId: shipmentData.residualShipmentId,
                orderNo: shipmentData.orderNo,
                comment: shipmentData.comment,
                notes: shipmentData.notes || ''
            };
            this.pickupDateTime(shipmentData.pickupDate);
        }
    }

    mapShipmentToModel(shipmentData, isParent = false) {
        return {
            requestLoad: shipmentData.amountLoadRequested,
            actualLoad: this.validateActualLoad(shipmentData),
            crv: shipmentData.amountCRV >= 0 ? shipmentData.amountCRV : '',
            expectedResidual: this.validateExpectedResidual(shipmentData),
            countedResidual: this.validateCountedResidual(shipmentData),
            variance: '',
            denomActualLoad: '',
            denomExpectedResidual: '',
            denomCountedResidual: '',
            faceValue: shipmentData.faceValue !== null ? shipmentData.faceValue : 1,
            coinFlag: shipmentData.coinFlag,
            trackingId: shipmentData.trackingId,
            finishedAt: shipmentData.finishedAt ? moment(shipmentData.finishedAt).format('MM-DD-YYYY | h:mm A') : '',
            remaining: shipmentData.finishedAt ? this.successCount++ : 0,
            currencyIcon: shipmentData.currencyId,
            denominationId: shipmentData.denominationId,
            denominationSymbol: shipmentData.denominationSymbol,
            comments: '',
            notes: shipmentData.notes || '',
            orderType: shipmentData.orderType,
            isEC: shipmentData.isEC,
            isLoadShipmentIsOnHold: shipmentData.isLoadShipmentIsOnHold,
            loadedAmount: shipmentData.loadedAmount,
            atmResidualId: shipmentData.atmResidualId,
            residualAmount: shipmentData.amount,
            branchId: shipmentData.branchId,
            routeId: shipmentData.routeId,
            vaultDate: moment.utc(shipmentData.vaultDate).format('MM-DD-YYYY'),
            toLocation: shipmentData.toLocation,
            fromLocation: shipmentData.fromLocation,
            isDeliveryShipmentDeleted: shipmentData.isDeliveryShipmentDeleted,
            isParent: isParent, // Adding a flag to identify if it's a parent shipment
            transferredAmount: shipmentData.transferredAmount || 0,
            dispensedAmount: shipmentData.dispensedAmount || 0,
            denomTransferredAmount: '',
            denomDispensedAmount: '',
            account: shipmentData.isEC ? 'emergency' : 'regular',
            orderNo: shipmentData.orderNo,
            madeCRV: shipmentData.madeCRV || 0,
            divertedAmount: shipmentData.divertedAmount !== undefined ? shipmentData.divertedAmount : null,
            unitValue: shipmentData.unitValue,
            coinPackaging: shipmentData.coinPackaging
        };
    } 
    calculateAmountForParent() {
        if (!this.model.parentAtmResidual) return;
    
        let data = this.model.parentAtmResidual;
        
        // Initialize calculation variables
        let expectedResidual = data.expectedResidual ? data.expectedResidual : 0;
        let requestLoad = data.requestLoad ? data.requestLoad : 0;
        let actualLoad = data.actualLoad ? data.actualLoad : 0;
        let crv = data.crv ? data.crv : 0;
        // Perform necessary calculations for the parent residual
        // As parent atm residual record deleted so sum of child
        let totalActualLoad = this.model.atmResidual.reduce((sum, record) => {
            return sum + (Number(record.actualLoad));
        }, 0);

        let totalExpectedResidual = this.model.atmResidual.reduce((sum, record) => {
            return sum + (Number(record.expectedResidual));
        }, 0);

        data.actualLoad = totalActualLoad;
        data.expectedResidual = totalExpectedResidual;
   
        if (data.finishedAt && data.crv != null && !this.isEdit) {
            data.crv;
        } else if (data.finishedAt && (data.crv === '' || data.crv === undefined)) {
            data.crv = 0;
        } else {
            data.crv = requestLoad - actualLoad;
        }
        // Denominated values
        data.denomActualLoad = (actualLoad / data.faceValue).toLocaleString();
        data.denomExpectedResidual = totalExpectedResidual;

        let transferredAmount = data.transferredAmount || 0;
        let dispensedAmount = data.dispensedAmount || 0;
        let countedResidual = data.countedResidual || 0;
        
        data.denomTransferredAmount = (transferredAmount / data.faceValue).toLocaleString(); 
        data.denomDispensedAmount = (dispensedAmount / data.faceValue).toLocaleString();
        // Calculate variance for the parent
        // data.variance = actualLoad - (crv + expectedResidual);
        data.variance = countedResidual - expectedResidual;
    
        // Update totals
        this.totalAmount();
    }

    pickupDateTime(pickupDate) {
        if (pickupDate) {
            const time = moment(pickupDate).tz(this.browserTimezone).format('HH:mm:ss');
            const validatationTime = moment.utc(pickupDate).format('HH:mm:ss')

            if (validatationTime === '00:00:00') {
                this.model.beginTime = null;
                this.pickupDate = moment(pickupDate, 'YYYY-MM-DD').toDate();
            } else {
                this.model.beginTime = this.DateUtil.getTime(time);
                const dateString = moment(pickupDate).tz(this.browserTimezone).format('YYYY-MM-DD');
                this.pickupDate = moment(dateString, 'YYYY-MM-DD').toDate();
            }
        }
        else {
            this.model.beginTime = "";
            this.pickupDate = "";
        }
    }

    validateActualLoad(data, index) {
        if (data.actualLoad) {
            return data.actualLoad;
        }
        else if (data.orderType === "T" || data.orderType === "P") {
            return 0;
        }
        else {
            return '';
        }
    }

    validateCountedResidual(data, index) {
        if (data.amountCounted !== null) {
            return data.amountCounted;
        }
        else if (data.orderType === "A" || data.orderType === "I" || data.orderType === "R" || data.orderType === "C" || data.isEC) {
            return 0;
        }
        else {
            return '';
        }
    }

    validateExpectedResidual(data, index) {
        if (data.amountExpected) {
            return data.amountExpected;
        }
        // else if (data.orderType === "A" || data.orderType === "I" || data.orderType === "R" || data.orderType === "C" || data.isEC) {
        //     return 0;
        // }
        else {
            return 0;
        }
    }

    // show ATM residual receipt 
    showResidualReceipt(shipments) {
        this.Modal.atmResidualReceipt(shipments, ({ modal }) => {
        }, ({ modal }) => {
            modal.close();
        });
    }

    editResidualCommit() {
        if (this.isEdit) {
            return this.commitResidualShipment(0);
        }
        this.isEdit = true;
        this.restorePreviousUnfitDenominations();
        if (!this.model.bagId) return this.model.bagId = this.lastScanned;
    }


    editDepositCommit() {
        if (this.isEdit) {
            return this.commitDeposit(0);
        }
        this.isEdit = true;
        if (!this.model.bagId) return this.model.bagId = this.lastScanned;
    }

    showEditDepositButton() {
        try {
            return !!(this.model && this.model.depositRecord && this.model.depositRecord.depositShipment &&
                this.model.locationId && this.hasACL && this.hasACL['atm_count'] && this.hasACL['atm_count']['editCommitted'] && this.finishedAt);
        } catch (e) {
            console.error(e)
            return false;
        }
    }
    isEditDepositButtonDisabled() {
        if (!this.isSameVaultDate) return true;
        if (this.isCommit) return true;
        if (this.isBulkCash && !this.allowBulkCashEdit) return true;
        if (this.isEdit && !this.model.bagId) return true;
        if (this.isEdit && !this.hasDenominationvalueChanged()) return true;
        if (this.model && this.model.depositRecord && !this.model.depositRecord.declaredTotalAmount) return true;
        if (this.isEdit && this.depositCommitDisabled && this.depositCommitDisabled()) return true;
        return false;
    }

    // redirect user to service history 
    redirectToLocation(locationId) {
        const obj = {
            locationId: locationId,
            isRedirected: true
        }
        this.DataCounter.setData(obj);
        this.$state.go('branchManagement.locations');
    }

    loadAtmCount(data) {
        const transitionData = this.FetchReactData.getTransitionData();
        this.locationData = transitionData || this.DataCounter.getData();
        let fundingSource;
        if ((this.locationData && this.locationData.isRedirected) || (this.locationLists.length === 1)) {
            if (this.locationData && this.locationData.fundingSourceId) {
                fundingSource = _.find(data, { id: this.locationData.fundingSourceId });
            }
            else if (this.locationData && this.locationData.destinationLocationId) {
                fundingSource = _.find(data, { locationId: this.locationData.destinationLocationId });
            }
            this.model.locationId = {
                Key: fundingSource ? (fundingSource.locationId + " | " + fundingSource.sourceName) : (data[0].locationId + " | " + data[0].sourceName),
                Value: fundingSource ? fundingSource.locationId : data[0].locationId,
                Id: fundingSource ? fundingSource.id : data[0].id,
                EditCountAnytime: fundingSource ? fundingSource.editCountAnytime : data[0].editCountAnytime,
                varianceCheckEnabled: fundingSource ? fundingSource.varianceCheckEnabled : data[0].varianceCheckEnabled,
                varianceThreshold: fundingSource ? fundingSource.varianceThreshold : data[0].varianceThreshold,
                currencyId: fundingSource ? fundingSource.currencyId : data[0].currencyId
            }
            this.setCurrencySymbol();
            if (this.locationData && this.locationData.isRedirected) this.model.bagId = this.locationData.trackingId;
            return this.bagCount().then(() => {
                this.loadShipmentByTrackingId();
                this.locationData.isRedirected = false;
                this.locationData = this.DataCounter.setData();
                this.FetchReactData.clearTransitionData();
            });
        }
    }

    residualCountEdit(children, parentResidual, comments, supervisorId) {
        const unfitDenomsData = this.prepareUnfitDenominationsData();
        
        const unfitTotal = (unfitDenomsData && this.model.unfitTotalCashCounted) ? this.model.unfitTotalCashCounted : 0;
        const totalCountedResidual = this.model.countedResidualTotal + unfitTotal;
        
        const updatedParentResidual = {
            ...parentResidual,
            countedResidual: totalCountedResidual
        };
        
        this.AtmResidualService.ResidualCountEdit(
            this.model.branch, 
            this.model.loggedInUserId, 
            children, 
            updatedParentResidual, 
            this.model.locationId.Id, 
            unfitDenomsData,
            this.monthlySupId,
            this.monthlyLimitDetails ? this.monthlyLimitDetails.monthlyCashCountLimitAmount : 0,
            this.monthlyLimitDetails ? this.monthlyLimitDetails.totalCountedThisMonth : 0,
            this.monthlyLimitDetails ? this.monthlyLimitDetails.newCountAmount : 0
        )
            .then((res) => {
                this.isCommit = false;
                this.updateData();
                this.model.bagId = this.lastScanned;
                this.loadShipmentByTrackingId();
            })
            .catch((err) => {
                this.isCommit = false;
                if (err && err.data && err.data.message) {
                    this.Sound.PlayErrorBeep("#scanner_beep");
                    this.Modal.errorModal('error.' + err.data.message)
                }
            })
    }

    updateData() {
        this.model.parentAtmResidual.finishedAt = moment().format('MM-DD-YYYY | h:mm A');
        this.model.atmResidual.forEach(residual => residual.finishedAt = moment().format('MM-DD-YYYY | h:mm A')); 
        this.finishedAt = this.model.parentAtmResidual.finishedAt;
        
        this.model.bagId = "";
        this.isEdit = false;
        this.focusElementById('trackingId');
    }

    validateResidualCountEdit() {
        this.isSameVaultDate = true;
        return this.AtmResidualService.getVaultDate(this.model.branch, this.lastScanned)
            .then((data) => {
                let shipmentVaultDate = new Date(data.shipmentVaultDate);
                let branchCurrentVaultDate = new Date(data.branchCurrentVaultDate);
                if(this.model.locationId && !this.model.locationId.EditCountAnytime) this.isSameVaultDate = shipmentVaultDate.getUTCDate() === branchCurrentVaultDate.getUTCDate();
                else if (this.model.locationId && this.model.locationId.EditCountAnytime) this.isSameVaultDate = true;
            })
            .catch((err) => {
                console.log(err);
            })
    }

    getComments(comment) {
        this.Modal.confirm({
            header: this.$translate.instant('common.comment'),
            message: comment,
            callback: (({
                modal
            }) => {
                modal.close();
            }),
            negative: (({
                modal,
            }) => {
                modal.close();
            }),
            buttons: ['common.close'],
            type: 'success'
        })
    }

    resetData() {
        this.model.bagId = null;
        this.shipmentData = [];
        this.isError = true;
        this.isBagout = false;
        this.model.depositRecord.depositShipment=null;
        this.resetBulkDepositData();
    }

    convertToCrv(shipment, modal=undefined) {
        modal.close();

        this.UsersService.checkSupervisor(this.model.loggedInUserId)
            .then((userInfo) => {
                shipment.amount = shipment.requestLoad;
                this.Modal.convertToCrv(shipment, !userInfo.supervisor, true, ({ supervisor, trackingIdResidual, modal }) => {
                    if (trackingIdResidual) {
                        return this.AtmResidualService.convertToCRV(shipment.branchId, shipment.routeId, trackingIdResidual, userInfo.supervisor ? userInfo.id : supervisor)
                            .then(() => {
                                this.Modal.confirm({
                                    header: this.$translate.instant('successModal.title'),
                                    message: this.$translate.instant(`ATM Residual <b>${this.model.bagId}</b> successfully Became CRV`),
                                    callback: (({
                                        modal
                                    }) => {
                                        this.reloadData();
                                        modal.close();
                                    }),
                                    buttons: ['common.ok'],
                                    type: 'success'
                                })
                            })
                            .catch((err) => {
                                if (err && err.data && err.data.message) {
                                    this.Modal.errorModal('error.' + err.data.message);
                                    this.reloadData();
                                }
                            })
                            .finally(() => {
                                modal.close();
                            })
                    }
                    else {
                        if (modal) modal.close();
                    }
                }, ({ modal }) => {
                    if (modal) modal.close();
                })
            })
            .catch((err) => {
                this.Modal.errorModal(err.data.message);
            })
    }

    reloadData() {
        this.resetData();
        this.bagCount();
        this.focusElementById('trackingId');
    }

    cancelEdit() {
        this.isEdit = false;
        this.expectedResidualDetails = [];
        this.loadShipments();
    }

    hasDenominationvalueChanged() {
        if ((this.model.depositRecord.notes || '') !== (this.model.depositRecord.previousNotes || '')) {
            return true;
        }
        if(Array.isArray(this.model.depositRecord.previousDenominations)){
            for (let itemA of this.model.depositRecord.previousDenominations) {
                const itemB = this.model.depositRecord.denominations.find(item => item.id === itemA.id);
                if (!itemB || itemA.totalValue !== itemB.totalValue) {
                    return true;
                }
            }
        }
        return false;
    }

    cancelDepositCountEdit() {
        this.isEdit = false;
        this.loadDepositShipment();
    }

    hasResidualCountvalueChanged() {
        for (let itemA of this.model.cloneAtmResidual) {
            const itemB = this.model.atmResidual.find(item => item.id === itemA.id);
            if (!itemB || itemA.totalValue !== itemB.totalValue) {
                return true;
            }
        }
        return false;
    }

    getExpectedResidual() {
        if (!this.model.parentAtmResidual || !this.model.parentAtmResidual.orderNo) return;

        this.gettingExpectedResidual = true;
        this.isPressExpectedResidualButton = true;

        const data = this.model.atmResidual.map(d => {
            const expectedResidualDetails = this.expectedResidualDetails && this.expectedResidualDetails.length > 0
                ? this.expectedResidualDetails.find(item => item.trackingId === d.trackingId)
                : {};

            const multiplier = (d.coinPackaging === 'ROLLED' || d.coinPackaging === 'INDIVIDUAL') && d.unitValue != null
                ? d.unitValue
                : d.faceValue;

            return {
                trackingId: d.trackingId,
                denominationId: d.denominationId,
                toLocationId: this.model.locationId.Value,

                crv: d.crv != null && d.crv !== "" ? Number(parseFloat(d.crv).toFixed(4)) : 0,

                denomTransferredAmount: d.denomTransferredAmount != null && d.denomTransferredAmount !== "" ?
                    Number((parseFloat(d.denomTransferredAmount.toString().replace(/,/g, "")) * multiplier).toFixed(4)) : 0,

                dispensedAmount: d.dispensedAmount != null && d.dispensedAmount !== "" ?
                    Number(parseFloat(d.dispensedAmount).toFixed(4)) : 0,

                countedResidual: d.countedResidual != null && d.countedResidual !== "" ?
                    Number(parseFloat(d.countedResidual).toFixed(4)) : 0,

                actualPriorLoad: expectedResidualDetails ?
                    Number(parseFloat(expectedResidualDetails.actualPriorLoad || 0).toFixed(4)) : 0,

                manualPriorLoadAmount: expectedResidualDetails ?
                    Number(parseFloat(expectedResidualDetails.manualPriorLoadAmount || 0).toFixed(4)) : 0,

                faceValue: d.faceValue,

                amountExpected: d.denomExpectedResidual != null && d.denomExpectedResidual !== "" ?
                    Number((parseFloat(d.denomExpectedResidual.toString().replace(/,/g, "")) * multiplier).toFixed(4)) : 0,

                hasManuallySetPriorLoad: expectedResidualDetails ? expectedResidualDetails.hasManuallySetPriorLoad || false : false,

                actualLoad: d.actualLoad != null && d.actualLoad !== "" ?
                    Number(parseFloat(d.actualLoad).toFixed(4)) : 0
            }
        });
        const resultMap = {};
        
        return this.AtmResidualService.getExpectedResidual(this.model.branch, this.lastScanned, data, this.model.locationId.Id, this.model.parentAtmResidual.orderNo)
            .then((data) => {
                this.expectedResidualDetails = data.results;
                this.model.expectedResidualToSend = 0;
                this.model.varianceToSend = 0;
                this.totalResidualAmount = data.expectedResidualAmount;

                data.results.forEach(item => {
                    item.actualPriorLoad = item.actualPriorLoad;
                    item.manualPriorLoadAmount = item.manualPriorLoadAmount ? item.manualPriorLoadAmount : item.hasManuallySetPriorLoad ? item.actualPriorLoad : 0;
                    item.isEditablePriorLoad = item.manualPriorLoadAmount > 0 ? true : false;
                    item.isValidAmount = item.isValidAmount || true;
                    resultMap[item.trackingId] = item;
                });

                const expectedResidualTotal = data.results.reduce((sum, item) => sum + item.expectedResidual, 0);

                this.model.atmResidual.forEach(d => {
                    const result = resultMap[d.trackingId];

                    if (result) {
                        let divisor = (d.coinPackaging === 'ROLLED' || d.coinPackaging === 'INDIVIDUAL') && d.unitValue != null
                            ? d.unitValue
                            : d.faceValue;

                        // prevent division by zero in case of bad data
                        divisor = divisor || 1;

                        d.expectedResidual = result.expectedResidual;
                        d.denomExpectedResidual = (result.expectedResidual / divisor).toLocaleString();
                        d.variance = result.variance;
                        d.actualPriorLoad = result.actualPriorLoad;
                        d.manualPriorLoadAmount = result.manualPriorLoadAmount;
                        d.faceValue = d.faceValue;
                        d.hasManuallySetPriorLoad = result.hasManuallySetPriorLoad;

                        this.model.expectedResidualToSend += Number(d.expectedResidual / divisor);
                        this.model.varianceToSend += Number(d.variance);
                    }
                });

                this.manualPriorLoadDenominations = this.expectedResidualDetails
                    .filter((d) => { return d.hasManuallySetPriorLoad && d.manualPriorLoadAmount > 0; })
                    .map((d) => { return d.denominationId; });

                const totalVariance = this.model.atmResidual.reduce((sum, item) => sum + item.variance, 0);

                this.model.parentAtmResidual.expectedResidual = expectedResidualTotal;
                this.model.expectedResidualTotal = expectedResidualTotal;
                this.model.parentAtmResidual.denomExpectedResidual = expectedResidualTotal;
                this.model.varianceTotal = totalVariance;
            })
            .catch((err) => {
                this.Modal.errorModal(err.data.message);
            })
            .finally(() => {
                this.gettingExpectedResidual = false;
            })
    }

    hasCountingBag() {
    if (!this.bulkDepositData.bags) return false;
    return Object.values(this.bulkDepositData.bags).some(bag => bag.status === 'counting');
    }

    getCountingBagIndex() {
        if (!this.bulkDepositData.bags) return null;
        const entries = Object.entries(this.bulkDepositData.bags);
        const countingEntry = entries.find(([index, bag]) => bag.status === 'counting');
        return countingEntry ? parseInt(countingEntry[0]) : null;
    }

    setActiveBag(bagIndex, loadData = true) {
        if (this.activeBagData.bagIndex !== null && this.activeBagData.bagIndex !== bagIndex) {
            this.clearActiveBag();
        }
        
        this.activeBagData.bagIndex = bagIndex;
        this.activeBagData.bag = this.bulkDepositData.bags[bagIndex];
        
        if (this.activeBagData.bag) {
            this.activeBagData.originalBagValues = {
                countedAmount: this.activeBagData.bag.countedAmount || 0,
                countedVariance: this.activeBagData.bag.countedVariance || 0,
                declaredAmount: this.activeBagData.bag.declaredAmount || null
            };
            this.originalCountAmount = this.activeBagData.originalBagValues.countedAmount || 0;
        }
        
        if (loadData && this.activeBagData.bag) {
            this.loadActiveBagData();
        }
    }
    
    clearActiveBag() {
        this.activeBagData = this._getDefaultActiveBagData();
    }

    getActiveBag() {
        return this.activeBagData.bag;
    }

    isBagActive(bagIndex) {
        return this.activeBagData.bagIndex === bagIndex;
    }

    getBagsArray() {
        return Object.keys(this.bulkDepositData.bags)
            .map(key => parseInt(key))
            .sort((a, b) => a - b);
    }

    getBagByIndex(bagIndex) {
        return this.bulkDepositData.bags[bagIndex];
    }

    isBagExpanded(bagIndex) {
        return this.isBagActive(bagIndex);
    }

    isBagInEditMode(bagIndex) {
        return this.isBagActive(bagIndex) && this.activeBagData.isEditMode;
    }

    isBagCollapseDisabled(bagIndex) {
        return false; 
    }

    onBulkDepositDeclaredTotalChange() {
        this.calculateBulkDepositTotals();
    }

    bulkDepositCommitDisabled() {
        if (!this.activeBagData.bag) return true;
        const bag = this.activeBagData.bag;
        
        if (bag.status === 'counted' && this.activeBagData.isEditMode) {
            return !this.hasBagDenominationValueChanged();
        }
        
        return bag.status === 'counted' && !this.activeBagData.isEditMode;
    }

    hasBagDenominationValueChanged() {
        if (!this.activeBagData.depositData.previousDenominations || 
            !this.activeBagData.depositData.denominations) {
            return false;
        }
        
        const previous = this.activeBagData.depositData.previousDenominations;
        const current = this.activeBagData.depositData.denominations;
        
        for (let prevDenom of previous) {
            const currDenom = current.find(item => item.id === prevDenom.id);
            if (!currDenom || prevDenom.totalValue !== currDenom.totalValue) {
                return true;
            }
        }
        
        return false;
    }

    updateBagDenomsTotals(bagIndex) {
        const bag = this.bulkDepositData.bags[bagIndex];
        if (!bag || !this.activeBagData.depositData.denominations) return;
        
        const denoms = this.activeBagData.depositData.denominations;
        
        bag.cashDenomTotals = denoms
            .filter(d => !d.coinFlag && !d.unfit)
            .reduce((sum, d) => sum + (Number(d.totalCounted * d.faceValue) || 0), 0);
        
        bag.coinDenomTotals = denoms
            .filter(d => d.coinFlag && !d.unfit)
            .reduce((sum, d) => sum + (Number(d.totalCounted * d.faceValue) || 0), 0);
        
        bag.unfitDenomTotals = denoms
            .filter(d => d.unfit)
            .reduce((sum, d) => sum + (Number(d.totalValue) || 0), 0);
    }

    resetBulkDepositData() {
        this.isBulkDeposit = false;
        this.bulkDepositData = this._getDefaultBulkDepositData();
        this.clearActiveBag();
    }

    loadBulkDepositShipment() {
        if (this.shipmentLoading || !this.model.locationId || !this.model.bagId) return;
        this.shipmentLoading = true;
        this.lastScanned = this.model.bagId;
        this.finishedAt = null;
        this.bulkDepositData = this._getDefaultBulkDepositData();
        this.clearActiveBag();

        this.AtmResidualDepositService.getBulkDepositShipmentRecord(this.model.bagId, this.model.locationId.Value)
        .then((data) => {
            this.shipmentLoading = false;
            
            if (data && data.shipmentRecord) {
                this.fromLocationId = data.shipmentRecord.fromLocationId;
                this.fromLocationName = data.shipmentRecord.fromLocation ? data.shipmentRecord.fromLocation.name : '';
                
                this.bulkDepositData.shipment = data.shipmentRecord;
                this.bulkDepositData.statedTotal = data.shipmentRecord.amount || 0;
                
                if (data.shipmentRecord.shiptype) {
                    this.bulkDepositData.metadata.shiptype = {
                        countable: data.shipmentRecord.shiptype.countable === 1 || data.shipmentRecord.shiptype.countable === true,
                        daysToCount: data.shipmentRecord.shiptype.daysToCount || 0
                    };
                }
                
                const isDeleted = data.shipmentRecord.deleted === true || data.shipmentRecord.deleted === 1;
                if (isDeleted) {
                    this.isEdit = false;
                }
                
                this.pickupDateTime(data.shipmentRecord.pickupDate);
                
                this.bulkDepositData.bags = {};
                this.bulkDepositData.metadata.nextBagIndex = 0;
                this.bulkDepositData.declaredTotal = data.shipmentRecord.amount || 0;
                this.bulkDepositData.countedTotal = 0;
                this.bulkDepositData.countedVariance = 0;
                
                if (data.individualBags && data.individualBags.length > 0) {
                    this.loadExistingBags(data.individualBags);
                }
                
                this.bulkDepositData.metadata.hasActiveBulkDeposit = true;
                this.isEdit = true;
                
                this.validateBulkDepositVaultDate();
            }
        })
        .catch((err) => {
            this.Modal.errorModal(err.data && err.data.message ? err.data.message : 'Error loading bulk deposit');
            this.shipmentLoading = false;
            this.isBulkDeposit = false;
        });
    }

    loadExistingBags(bagsArray) {
        bagsArray.forEach((bagData, index) => {
            let bagStatus = 'pending';
            if (bagData.depositRecord && bagData.depositRecord.countedAt) {
                bagStatus = 'counted';
            } else if (bagData.countCompletedAt) {
                bagStatus = 'counted';
            } else if (bagData.id || bagData.shipmentId) {
                bagStatus = 'counting';
            }
            
            const countedAmount = bagData.depositRecord 
                ? (bagData.depositRecord.totalAmount || 0) 
                : (bagData.countedAmount || 0);
            
            const countedVariance = bagData.depositRecord
                ? (bagData.depositRecord.countedVariance || 0)
                : (bagData.countedVariance || 0);
            
            this.bulkDepositData.bags[index] = {
                trackingId: bagData.trackingId || '',
                declaredAmount: bagData.depositRecord ? bagData.depositRecord.declaredTotalAmount : (bagData.amount || null),
                countedAmount: countedAmount,
                countedVariance: countedVariance,
                status: bagStatus,
                shipmentId: bagData.id || bagData.shipmentId || null,
                depositRecordId: bagData.depositRecordId || (bagData.depositRecord ? bagData.depositRecord.id : null),
                countCompletedAt: bagData.countCompletedAt || (bagData.depositRecord ? bagData.depositRecord.countedAt : null) || null,
                countVaultDate: bagData.depositRecord ? (bagData.depositRecord.countVaultDate || null) : null,
                depositRecord: bagData.depositRecord || null,
                cashDenomTotals: 0,
                coinDenomTotals: 0,
                unfitDenomTotals: 0
            };
            
            this.bulkDepositData.metadata.nextBagIndex = Math.max(this.bulkDepositData.metadata.nextBagIndex, index + 1);
        });
        
        this.calculateBulkDepositTotals();
    }
    
    loadActiveBagData() {
        const bagIndex = this.activeBagData.bagIndex;
        const bag = this.activeBagData.bag;
        
        if (!bag || !bag.trackingId) {
            return this.$q.resolve();
        }
        
        if (bag.status === 'counting' && !bag.depositRecordId && !bag.depositRecord) {
            let filteredDenominations = this.allDenominations || [];
            if (this.model.locationId && this.model.locationId.currencyId) {
                filteredDenominations = this.allDenominations.filter((o) => o.currencyId === this.model.locationId.currencyId);
            }
            
            this.activeBagData.depositData = {
                depositShipment: null,
                depositRecord: null,
                declaredTotalAmount: bag.declaredAmount || 0,
                countedVariance: bag.countedVariance || 0,
                totalAmount: bag.countedAmount || 0,
                statedTotalAmount: bag.declaredAmount || 0,
                denominations: angular.copy(filteredDenominations),
                previousDenominations: [],
                childTotalDeposit: 0,
                coinTotalDeposit: 0,
                unfitTotalDeposit: 0,
                codFlags: null
            };
            
            this.activeBagData.depositData.denominations.forEach(denom => {
                denom.totalCounted = 0;
                denom.totalValue = 0;
            });
            
            this.activeBagData.depositData.totalAmount = 0;
            this.activeBagData.depositData.childTotalDeposit = 0;
            this.activeBagData.depositData.coinTotalDeposit = 0;
            this.activeBagData.depositData.unfitTotalDeposit = 0;
            this.activeBagData.depositData.countedVariance = 0;
            
            this.calculateActiveBagTotals();
            this.updateBagDenomsTotals(bagIndex);
            
            return this.$q.resolve();
        }
        
        return this.AtmResidualDepositService.getDepositShipmentRecord(bag.trackingId, this.model.locationId.Value)
        .then((data) => {
            if (this.activeBagData.bagIndex !== bagIndex) {
                return;
            }
            bag.countCompletedAt = data.shipmentRecord.countCompletedAt || null;
            let filteredDenominations = this.allDenominations || [];
            if (this.model.locationId && this.model.locationId.currencyId) {
                filteredDenominations = this.allDenominations.filter((o) => o.currencyId === this.model.locationId.currencyId);
            }
            
            const bagCodFlags = {
                isPackable: data.shipmentRecord.isPackable || false,
                isCRVed: data.shipmentRecord.isCRVed || false,
                includedDenominationIds: data.shipmentRecord.includedDenominationIds || []
            };
            
            this.codFlags = bagCodFlags;
            this.setCountRestrictionFromShipment(data.shipmentRecord);
            
            this.activeBagData.depositData = {
                depositShipment: data.shipmentRecord,
                depositRecord: data.depositRecord,
                declaredTotalAmount: bag.declaredAmount || 0,
                countedVariance: bag.countedVariance || 0,
                totalAmount: bag.countedAmount || 0,
                statedTotalAmount: bag.declaredAmount || 0,
                denominations: angular.copy(filteredDenominations),
                previousDenominations: [],
                childTotalDeposit: 0,
                coinTotalDeposit: 0,
                unfitTotalDeposit: 0,
                codFlags: bagCodFlags
            };
            
            if (data.depositRecord) {
                bag.depositRecordId = data.depositRecord.id || bag.depositRecordId;
                this.activeBagData.depositRecordId = data.depositRecord.id || bag.depositRecordId;
                this.activeBagData.depositData.denominations = this.denomsDataUpdate(data.depositRecord.denominations);
                this.activeBagData.depositData.totalAmount = data.depositRecord.totalAmount || 0;
                
                const userDeclaredAmount = bag.declaredAmount;
                const dbDeclaredAmount = data.depositRecord.declaredTotalAmount;
                
                if (userDeclaredAmount !== null && userDeclaredAmount !== undefined) {
                    this.activeBagData.depositData.declaredTotalAmount = userDeclaredAmount;
                } else {
                    this.activeBagData.depositData.declaredTotalAmount = dbDeclaredAmount;
                    bag.declaredAmount = dbDeclaredAmount;
                }
                
                bag.countedAmount = data.depositRecord.totalAmount || 0;
                
                this.activeBagData.depositData.previousDenominations = _.cloneDeep(this.activeBagData.depositData.denominations);
                
                this.calculateActiveBagTotals();
                
                bag.countedVariance = this.activeBagData.depositData.countedVariance;
            } else {
                this.activeBagData.depositData.denominations.forEach(denom => {
                    denom.totalCounted = 0;
                    denom.totalValue = 0;
                });

                this.activeBagData.depositData.totalAmount = 0;
                this.activeBagData.depositData.childTotalDeposit = 0;
                this.activeBagData.depositData.coinTotalDeposit = 0;
                this.activeBagData.depositData.unfitTotalDeposit = 0;
                this.activeBagData.depositData.countedVariance = 0;
                
                bag.countedAmount = 0;
                bag.countedVariance = 0;
                this.calculateActiveBagTotals();
            }
            
            this.updateBagDenomsTotals(bagIndex);
        })
        .catch((err) => {
            console.error('Error loading active bag data:', err);
            return this.$q.resolve();
        });
    }

    calculateBulkDepositTotals() {
        let countedTotal = 0;
        let countedCount = 0;

        Object.values(this.bulkDepositData.bags).forEach(bag => {
            if (bag.status === 'counted' && bag.countedAmount) {
                countedTotal += Number(bag.countedAmount) || 0;
                countedCount++;
            }
        });

        this.bulkDepositData.countedTotal = countedTotal;
        this.bulkDepositData.countedVariance = Number(this.bulkDepositData.countedTotal || 0) - Number(this.bulkDepositData.declaredTotal || 0);
        
        return countedCount;
    }

    calculateActiveBagTotals() {
        if (!this.activeBagData.depositData.denominations) return;
        
        const depositData = this.activeBagData.depositData;
        const bag = this.activeBagData.bag;
        
        depositData.childTotalDeposit = depositData.denominations
            .filter(denom => !denom.coinFlag && !denom.unfit)
            .reduce((sum, denom) => sum + (Number(denom.totalCounted * denom.faceValue) || 0), 0);
        
        depositData.coinTotalDeposit = depositData.denominations
            .filter(denom => denom.coinFlag && !denom.unfit)
            .reduce((sum, denom) => sum + (Number(denom.totalCounted * denom.faceValue) || 0), 0);
        
        depositData.unfitTotalDeposit = depositData.denominations
            .filter(denom => denom.unfit)
            .reduce((sum, denom) => sum + (Number(denom.totalValue) || 0), 0);
        
        depositData.totalAmount = Number(depositData.childTotalDeposit) + 
                                  Number(depositData.coinTotalDeposit) + 
                                  Number(depositData.unfitTotalDeposit);
        
        const declaredTotal = Number(depositData.declaredTotalAmount) || 0;
        depositData.countedVariance = Number(depositData.totalAmount) - declaredTotal;
        
        if (bag) {
            bag.declaredAmount = declaredTotal;
            bag.countedAmount = depositData.totalAmount;
            bag.countedVariance = depositData.countedVariance;
        }
    }

    validateBulkDepositVaultDate() {
        if (!this.model.bagId || !this.model.branch) {
            return this.$q.resolve();
        }
        
        return this.AtmResidualService.getVaultDate(this.model.branch, this.model.bagId)
        .then((data) => {
            let shipmentVaultDate = new Date(data.shipmentVaultDate);
            let branchCurrentVaultDate = new Date(data.branchCurrentVaultDate);

            this.bulkDepositData.metadata.branchCurrentVaultDate = branchCurrentVaultDate;
            this.bulkDepositData.metadata.shipmentVaultDate = shipmentVaultDate;
        })
        .catch((err) => {
            this.bulkDepositData.metadata.branchCurrentVaultDate = null;
            this.bulkDepositData.metadata.shipmentVaultDate = null;
        });
    }

    isBulkDepositDeleted() {
        if (!this.bulkDepositData.shipment) return false;
        const deleted = this.bulkDepositData.shipment.deleted;
        return deleted === true || deleted === 1;
    }

    hasCountingBag() {
        if (!this.bulkDepositData || !this.bulkDepositData.bags) return false;
        const bags = this.bulkDepositData.bags;
        for (const key in bags) {
            const bag = bags[key];
            if (bag && bag.shipmentId && !bag.countCompletedAt) {
                return true;
            }
        }
        return false;
    }

    getCountingBagIndex() {
        if (!this.bulkDepositData || !this.bulkDepositData.bags) return null;
        const bags = this.bulkDepositData.bags;
        for (const key in bags) {
            const bag = bags[key];
            if (bag && bag.shipmentId && !bag.countCompletedAt) {
                return key;
            }
        }
        return null;
    }

    isBagLocked(bagIndex) {
        if (!this.hasCountingBag()) return false;
        const countingBagIndex = this.getCountingBagIndex();
        const normalizedCountingIndex = countingBagIndex !== null ? Number(countingBagIndex) : null;
        const normalizedBagIndex = Number(bagIndex);
        return normalizedCountingIndex !== null && normalizedCountingIndex !== normalizedBagIndex;
    }

    // isWithinDaysToCountLimit() {
    //     const shiptype = this.bulkDepositData.metadata.shiptype;
    //     if (!shiptype || !shiptype.countable) {
    //         return true;
    //     }
        
    //     const branchCurrentVaultDate = this.bulkDepositData.metadata.branchCurrentVaultDate;
    //     const shipmentVaultDate = this.bulkDepositData.metadata.shipmentVaultDate;
        
    //     if (!branchCurrentVaultDate || !shipmentVaultDate) {
    //         return false;
    //     }
        
    //     // Handle daysToCount = 0: Everything must happen on the same vault date as shipment
    //     if (shiptype.daysToCount <= 0) {
    //         return this.isSameDate(branchCurrentVaultDate, shipmentVaultDate);
    //     }
        
    //     // Handle daysToCount > 0: Check if current date is within the allowed range
    //     const currentMoment = moment(branchCurrentVaultDate);
    //     const shipmentMoment = moment(shipmentVaultDate);
    //     const daysDiff = currentMoment.diff(shipmentMoment, 'days');

    //     return daysDiff <= shiptype.daysToCount;
    // }
    
    isSameDate(date1, date2) {
        if (!date1 || !date2) return false;
        return moment(date1).isSame(moment(date2), 'day');
    }

    canEditBag(bagIndex) {
        const bag = this.bulkDepositData.bags[bagIndex];
        if (!bag || bag.status !== 'counted') return false;
        if (this.isBulkDepositDeleted()) return false;
        if (this.isBagLocked(bagIndex)) return false;
        
        if (bag.countVaultDate) {
            if (!this.model.vaultDate) return false;
            if (!this.isSameDate(this.model.vaultDate, bag.countVaultDate)) {
                return false;
            }
        }
        
        return true;
    }
    
    getBagEditRestrictionMessage(bagIndex) {
        const bag = this.bulkDepositData.bags[bagIndex];
        if (!bag || bag.status !== 'counted') return null;
        
        if (this.isBulkDepositDeleted()) {
            return 'This bulk deposit has been closed and is read-only.';
        }
        
        if (this.isBagLocked(bagIndex)) {
            return 'Cannot edit this bag while another bag is being counted.';
        }
        
        if (bag.countVaultDate && this.model.vaultDate) {
            if (!this.isSameDate(this.model.vaultDate, bag.countVaultDate)) {
                const countDate = moment(bag.countVaultDate).format('YYYY-MM-DD');
                const currentDate = moment(this.model.vaultDate).format('YYYY-MM-DD');
                return `Cannot edit: Bag was counted on ${countDate}, but current vault date is ${currentDate}.`;
            }
        }
        
        return null;
    }

    canStartBagCount(bagIndex) {
        if (this.isBagLocked(bagIndex)) return false;
        
        const bag = this.bulkDepositData.bags[bagIndex];
        if (!bag || bag.status !== 'pending') return false;
        
        const hasTrackingId = bag.trackingId && String(bag.trackingId).trim().length > 0;
        
        let declaredAmountValue = 0;
        if (bag.declaredAmount) {
            if (typeof bag.declaredAmount === 'string') {
                declaredAmountValue = parseFloat(bag.declaredAmount.replace(/[^0-9.-]/g, '')) || 0;
            } else {
                declaredAmountValue = Number(bag.declaredAmount) || 0;
            }
        }
        const hasDeclaredAmount = declaredAmountValue > 0;
        
        return hasTrackingId && hasDeclaredAmount;
        
        // return this.isWithinDaysToCountLimit();
    }

    addBulkDepositBag() {
        if (this.hasCountingBag()) {
            this.Modal.errorModal('Cannot add new bags while a bag is being counted.');
            return;
        }
        const newIndex = this.bulkDepositData.metadata.nextBagIndex;
        this.bulkDepositData.bags[newIndex] = this._getDefaultBagData();
        this.bulkDepositData.metadata.nextBagIndex++;
        this.calculateBulkDepositTotals();
    }

    removeBulkDepositBag(bagIndex) {
        const bag = this.bulkDepositData.bags[bagIndex];
        
        if (!bag) return;
        
        if (bag.status === 'counted' || bag.shipmentId) {
            this.Modal.errorModal('Cannot remove bags that have been counted.');
            return;
        }
        
        delete this.bulkDepositData.bags[bagIndex];
        this.calculateBulkDepositTotals();
    }

    updateBagTrackingId(bagIndex, trackingId) {
        if (this.isBagLocked(bagIndex)) return;
        
        const bag = this.bulkDepositData.bags[bagIndex];
        if (bag && bag.trackingId !== trackingId) {
            bag.trackingId = trackingId;
        }
    }

    updateBagDeclaredAmount(bagIndex, declaredAmount) {
        if (this.isBagLocked(bagIndex)) return;
        
        const bag = this.bulkDepositData.bags[bagIndex];
        if (!bag) return;
        
        let numericValue = declaredAmount;
        if (typeof declaredAmount === 'string') {
            numericValue = parseFloat(declaredAmount.replace(/[^0-9.-]/g, '')) || null;
        }
        
        bag.declaredAmount = numericValue;
        
        if (this.isBagActive(bagIndex)) {
            this.activeBagData.depositData.declaredTotalAmount = numericValue;
            this.calculateActiveBagTotals();
        }
        
        this.calculateBulkDepositTotals();
    }

    toggleBagCollapse(bagIndex) {
        const bag = this.bulkDepositData.bags[bagIndex];
        if (!bag) return;
        
        const canExpand = bag.status === 'counting' || bag.status === 'counted' || bag.shipmentId;
        if (!canExpand) return;
        
        // If this bag is already active, restore original values and clear it (collapse)
        if (this.isBagActive(bagIndex)) {
            if (this.activeBagData.originalBagValues) {
                const original = this.activeBagData.originalBagValues;
                bag.countedAmount = original.countedAmount;
                bag.countedVariance = original.countedVariance;
                bag.declaredAmount = original.declaredAmount;
            }
            
            if (this.activeBagData.isEditMode) {
                this.activeBagData.isEditMode = false;
            }
            
            this.calculateBulkDepositTotals();
            this.clearActiveBag();
            return;
        }
        
        this.setActiveBag(bagIndex, true);
    }

    startBagCount(bagIndex) {
        const bag = this.bulkDepositData.bags[bagIndex];
        if (!this.canStartBagCount(bagIndex)) {
            this.Modal.errorModal('Please provide tracking ID and declared amount');
            return;
        }

        if (bag.shipmentId) {
            bag.status = 'counting';
            this.setActiveBag(bagIndex, true);
            return;
        }

        this.shipmentLoading = true;
        this.AtmResidualDepositService.createIndividualBagShipment(
            this.bulkDepositData.shipment.trackingId,
            bag.trackingId,
            bag.declaredAmount,
            this.model.loggedInUserId
        )
        .then((data) => {
            this.shipmentLoading = false;
            if (data && data.success) {
                bag.shipmentId = data.shipmentId;
                bag.status = 'counting';
                this.setActiveBag(bagIndex, true);
            }
        })
        .catch((err) => {
            this.shipmentLoading = false;
            this.Modal.errorModal(err.data && err.data.message ? err.data.message : 'Error creating bag shipment');
        });
    }

    activeBagDenomChange(denomId) {
        if (!this.activeBagData.depositData.denominations) return;
        
        const index = this.activeBagData.depositData.denominations.findIndex((item) => item.id === denomId);
        
        if (index !== -1) {
            const denom = this.activeBagData.depositData.denominations[index];
            const countedTotal = Number(denom.totalCounted * denom.faceValue) || 0;
            denom.totalValue = countedTotal;
        }
        
        this.calculateActiveBagTotals();
        this.updateBagDenomsTotals(this.activeBagData.bagIndex);
    }
  
    commitActiveBagCount() {
        this.monthlySupId = null; 
        const bag = this.activeBagData.bag;

        const depositData = this.activeBagData.depositData;
        if (!bag || !depositData) {
            this.Modal.errorModal('No bag selected for counting');
            return;
        }

        if (depositData.totalAmount === 0) {
            this.Modal.errorModal('Please enter denomination counts');
            return;
        }

        if (!depositData.declaredTotalAmount || depositData.declaredTotalAmount <= 0) {
            this.Modal.errorModal('Declared amount must be greater than 0');
            return;
        }

        // if (!this.isWithinDaysToCountLimit()) {
        //     this.Modal.errorModal('Days to Count limit has been exceeded for shiptype');
        //     return;
        // }

        if (!this.pickupDate || !this.model.beginTime) {
            this.Modal.errorModal('Pickup date and time are required before committing this bag.');
            return;
        }

        let newAmount = depositData.totalAmount || 0;
        this.checkMonthlyCountLimit(newAmount).then(() => {
            if (depositData.countedVariance && depositData.countedVariance !== 0) {
                this.Modal.residualComments({ trackingId: bag.trackingId }, ({ modal, comments }) => {
                    this._executeActiveBagCommit(comments);
                    modal.close();
                }, ({ modal }) => {
                    modal.close();
                });
            } else {
                this._executeActiveBagCommit(null);
            }
        });
    }

    _executeActiveBagCommit(comment) {
        const bag = this.activeBagData.bag;
        const depositData = this.activeBagData.depositData;

        const denomsData = depositData.denominations.map((denom) => {
            return {
                denominationId: denom.id,
                quantity: Number(denom.totalCounted) || 0
            };
        });

        const fundingSource = this.model.locationId.Id;
        const trackingId = bag.trackingId;
        const branchId = this.model.branch;
        const pickupDate = moment(this.pickupDate).format('YYYY-MM-DD');
        const pickupTime = moment(this.model.beginTime).format('HH:mm:ss');
        const branchTimeZone = this.branchTimeZone;
        const countedByUserId = this.model.loggedInUserId;
        const declaredTotalAmount = depositData.declaredTotalAmount;
        const countedVariance = depositData.countedVariance;

        this.checkSupervisorApproval(countedVariance).then((supId) => {
            this.isBulkDepositCommit = true;

            if (bag.depositRecordId) {
                this.AtmResidualDepositService.editDepositCount(
                    fundingSource,
                    trackingId,
                    comment,
                    denomsData,
                    branchId,
                    pickupDate,
                    pickupTime,
                    branchTimeZone,
                    countedByUserId,
                    bag.depositRecordId,
                    declaredTotalAmount,
                    countedVariance,
                    supId, this.browserTimezone, this.monthlySupId, this.monthlyLimitDetails ? this.monthlyLimitDetails.monthlyCashCountLimitAmount : 0, this.monthlyLimitDetails ? this.monthlyLimitDetails.totalCountedThisMonth : 0, this.monthlyLimitDetails ? this.monthlyLimitDetails.newCountAmount : 0
                )
                .then(() => {
                    this.isBulkDepositCommit = false;
                    
                    bag.countedAmount = depositData.totalAmount;
                    bag.countedVariance = depositData.countedVariance;
                    
                    if (depositData.denominations) {
                        depositData.previousDenominations = _.cloneDeep(depositData.denominations);
                    }
                    this.loadActiveBagData().then(() => {
                        this.activeBagData.isEditMode = false;
                        this.clearActiveBag();
                        this.calculateBulkDepositTotals();
                    });
                })
                .catch((err) => {
                    this.isBulkDepositCommit = false;
                    if (err && err.data && err.data.message) {
                        this.Sound.PlayErrorBeep("#scanner_beep");
                        this.Modal.errorModal('error.' + err.data.message);
                    } else {
                        this.Modal.errorModal('Error editing bag count');
                    }
                });
            } else {
                this.AtmResidualDepositService.commitDepositCount(
                    fundingSource,
                    trackingId,
                    comment,
                    denomsData,
                    branchId,
                    pickupDate,
                    pickupTime,
                    branchTimeZone,
                    countedByUserId,
                    declaredTotalAmount,
                    countedVariance,
                    supId, this.browserTimezone, this.monthlySupId, this.monthlyLimitDetails ? this.monthlyLimitDetails.monthlyCashCountLimitAmount : 0, this.monthlyLimitDetails ? this.monthlyLimitDetails.totalCountedThisMonth : 0, this.monthlyLimitDetails ? this.monthlyLimitDetails.newCountAmount : 0
                )
                .then(() => {
                    this.isBulkDepositCommit = false;
                    
                    bag.status = 'counted';
                    bag.countedAmount = depositData.totalAmount;
                    bag.countedVariance = depositData.countedVariance;
                    this.activeBagData.isEditMode = false;
                    this.loadActiveBagData().then(() => {
                        this.activeBagData.isEditMode = false;
                        this.clearActiveBag();
                        this.calculateBulkDepositTotals();
                    });

                    this.Sound.playSuccessBeep("#success_beep");
                })
                .catch((err) => {
                    this.isBulkDepositCommit = false;
                    if (err && err.data && err.data.message) {
                        this.Sound.PlayErrorBeep("#scanner_beep");
                        this.Modal.errorModal('error.' + err.data.message);
                    } else {
                        this.Modal.errorModal('Error committing bag count');
                    }
                });
            }
        }).catch((err) => {
            this.isBulkDepositCommit = false;
        });
    }

    editBag(bagIndex) {
        const bag = this.bulkDepositData.bags[bagIndex];
        if (!bag || bag.status !== 'counted') {
            this.Modal.errorModal('Can only edit counted bags');
            return;
        }
        
        if (!bag.trackingId) {
            this.Modal.errorModal('Bag tracking ID is required');
            return;
        }
        
        if (!this.canEditBag(bagIndex)) {
            this.Modal.errorModal('Cannot edit bag: Parent bulk deposit must be on the same vault date or location must allow editing anytime');
            return;
        }
        
        this.activeBagData.originalBagValues = {
            countedAmount: bag.countedAmount || 0,
            countedVariance: bag.countedVariance || 0,
            declaredAmount: bag.declaredAmount || 0
        };
        
        this.setActiveBag(bagIndex, true);
        this.activeBagData.isEditMode = true;
    }

    cancelBagEdit() {
        const bagIndex = this.activeBagData.bagIndex;
        const bag = this.activeBagData.bag;
        
        if (!bag) return;
        
        const isBagStillExpanded = this.isBagActive(bagIndex);
        
        if (bag.status === 'counted' && bag.trackingId && isBagStillExpanded) {
            this.loadActiveBagData().then(() => {
                const depositData = this.activeBagData.depositData;
                if (depositData && depositData.depositRecord) {
                    bag.countedAmount = depositData.depositRecord.totalAmount || 0;
                    bag.countedVariance = depositData.depositRecord.countedVariance || 0;
                    bag.declaredAmount = depositData.depositRecord.declaredTotalAmount || bag.declaredAmount || 0;
                }
                
                if (this.activeBagData.originalBagValues) {
                    this.activeBagData.originalBagValues = null;
                }
                
                this.activeBagData.isEditMode = false;
                this.calculateBulkDepositTotals();
            });
        } else {
            // Restore original values
            if (this.activeBagData.originalBagValues) {
                const original = this.activeBagData.originalBagValues;
                bag.countedAmount = original.countedAmount;
                bag.countedVariance = original.countedVariance;
                bag.declaredAmount = original.declaredAmount;
                this.activeBagData.originalBagValues = null;
            }
            
            this.activeBagData.isEditMode = false;
            if (!isBagStillExpanded) {
                this.clearActiveBag();
            }
            this.calculateBulkDepositTotals();
        }
    }

    reopenBulkDepositCount() {
        this.Modal.confirm({
            header: this.$translate.instant('common.confirm_title'),
            message: 'Are you sure you want to reopen the bulk deposit?',
            callback: ({ modal }) => {
                const trackingId = this.bulkDepositData.shipment.trackingId;
                const userId = this.model.loggedInUserId;

                this.AtmResidualDepositService.reopenBulkDeposit(trackingId, userId)
                    .then(() => {
                        this.bagCount();
                        this.loadBulkDepositShipment();
                    })
                    .catch((err) => {
                        this.Modal.errorModal(err.data && err.data.message ? err.data.message : 'Error reopening bulk deposit count');
                    })
                    .finally(() => {
                        modal.close();
                    });
            },
            type: 'success',
            buttons: ['common.yes', 'common.no']
        });
    }

    closeBulkDepositCount() {
        this.monthlySupId = null; 

        const amount = this.bulkDepositData.countedTotal;
        this.checkMonthlyCountLimit(amount, 'bulkdeposit').then(() => {
            this.Modal.confirmSupervisor('close-bulk-deposit-count', { trackingId: this.bulkDepositData.shipment.trackingId },
                ({ modal, supId }) => {
                    this.finalizeBulkDepositCount(this.bulkDepositData.shipment.trackingId, supId);
                    modal.close();
                },
                ({ modal }) => {
                    modal.close();
                }
            );
        });
    }


    finalizeBulkDepositCount(trackingId, supId) {
        this.bulkDepositData.metadata.isClosingBulkDeposit = true;
        
        this.AtmResidualDepositService.finalizeBulkDeposit(
            trackingId,
            supId,
        )
        .then(() => {
            this.bulkDepositData.metadata.isClosingBulkDeposit = false;
            
            if (this.model.locationId) {
                this.bagCount();
            }
            
            this.Modal.confirm({
                header: this.$translate.instant('successModal.title'),
                message: this.$translate.instant('Bulk deposit count has been closed successfully.'),
                callback: ({ modal }) => {
                    modal.close();
                    this.resetBulkDepositData();
                    this.model.bagId = '';
                    this.focusElementById('trackingId');
                },
                type: 'success',
                buttons: ['common.close']
            });
        })
        .catch((err) => {
            this.bulkDepositData.metadata.isClosingBulkDeposit = false;
            this.Modal.errorModal(err.data && err.data.message ? err.data.message : 'Error closing bulk deposit count');
        });
    }

    allBagsCommitted() {
        const bagKeys = Object.keys(this.bulkDepositData.bags);
        if (bagKeys.length === 0) return false;
        
        return bagKeys.every(key => {
            const bag = this.bulkDepositData.bags[key];
            return bag.status === 'counted' && bag.trackingId && bag.declaredAmount;
        });
    }

    getCountedBagsCount() {
        return Object.values(this.bulkDepositData.bags)
            .filter(bag => bag.status === 'counted').length;
    }

    getTotalBagsCount() {
        return Object.keys(this.bulkDepositData.bags).length;
    }

    validateManuallyPriorLoadedAmount(denomination) {
        if (denomination.manualPriorLoadAmount > 0) {
            
            let divisor = (denomination.coinPackaging === 'ROLLED' || denomination.coinPackaging === 'INDIVIDUAL') && denomination.unitValue != null
                ? Number(denomination.unitValue)
                : Number(denomination.faceValue);
                
            divisor = divisor || 1;
            
            let scaledAmount = Math.round(Number(denomination.manualPriorLoadAmount) * 10000);
            let scaledDivisor = Math.round(divisor * 10000);

            denomination.isValidAmount = (scaledAmount % scaledDivisor) === 0;
            
        } else if (denomination.manualPriorLoadAmount == null || denomination.manualPriorLoadAmount === undefined || denomination.manualPriorLoadAmount === "") {
            denomination.isValidAmount = false;
        } else {
            denomination.isValidAmount = true;
        }
    }

    isDisableExpectedResidual() {
        if (this.expectedResidualDetails && this.expectedResidualDetails.length > 0) {
            return this.expectedResidualDetails.some(d => !d.isValidAmount && (d.manualPriorLoadAmount >= 0 || d.manualPriorLoadAmount == null || d.manualPriorLoadAmount == undefined));
        }
        return false;
    }
}

export default ATMCountController;




// WEBPACK FOOTER //
// ./client/app/components/atm_count/atm_count.controller.js